/* Wardrobe planner logic */
cabjaks.wardrobePlanner = function (options) {
	var moneyFormat = options.money_format,
	$wardrobePlanner = $('.wardrobe-planner'),
	$heading = $wardrobePlanner.find('.section-header'),
	$progress = $wardrobePlanner.find('.progress'),
	$tips = $wardrobePlanner.find('.tips-and-tricks'),
	$currentProductInfo = $tips.find('.current-product'),
	$currentProductImage = $currentProductInfo.find('.product-image img'),
	$step1 = $wardrobePlanner.find('.step-1'),
	$step2 = $wardrobePlanner.find('.step-2'),
	$savedPlan = $step1.find('.saved-plan'),
	$roomInputs = $step1.find('input#room-width, input#room-height'),
	$roomWidthInput = $step1.find('input#room-width'),
	$roomHeightInput = $step1.find('input#room-height'),
	$diagram = $wardrobePlanner.find('.diagram'),
	$dragInstructions = $diagram.find('.drag-instructions'),
	$overlay = $diagram.find('.overlay'),
	$productOptions = $diagram.find('.product-options'),
	$componentOptions = $productOptions.find('.component-options'),
	$towerOptions = $productOptions.find('.tower-options'),
	$componentAddBtn = $componentOptions.find('.btn-add'),
	$componentConfigureBtn = $componentOptions.find('.btn-configure'),
	$ruler = $diagram.find('.ruler'),
	$rulerX1 = $ruler.find('.x1'),
	$rulerX2 = $ruler.find('.x2'),
	$rulerX3 = $ruler.find('.x3'),
	$rulerY1 = $ruler.find('.y1'),
	$rulerY2 = $ruler.find('.y2'),
	$rulerY3 = $ruler.find('.y3'),
	$productSelect = $productOptions.find('select#productSelect'),
	$towerDrawersWrapper = $towerOptions.find('.drawer-options'),
	$towerDrawersSelect = $towerOptions.find('select#tower-drawers'),
	$towerShelvesSelect = $towerOptions.find('select#tower-shelves'),
	$productsList = $wardrobePlanner.find('.planner-products-list-section'),//$wardrobePlanner.find('.planner-products-list'),
	$additionalComponents = $step2.find('.additional-components'),
	$railSupportsQuantity = $additionalComponents.find('.rail-supports input[name=quantity]'),
	$shelfSupportsQuantity = $additionalComponents.find('.shelf-supports input[name=quantity]'),
	$shelfSupportsSelect = $additionalComponents.find('.shelf-supports select.variant-selector'),
	$handleSelection = $step2.find('.handle-selection'),
	$softCloseSelection = $step2.find('.soft-close-selection'),
	$handleUpgradePrice = $handleSelection.find('p.handle-upgrade-price'),
	$softClosePrice = $softCloseSelection.find('p.soft-close-price'),
	$saveButton = $wardrobePlanner.find('a.btn-save'),//$step2.find('a.btn-save'),
	$globalSaveButton = $('a.btn-global-save'),
	$summaryWrapper = $wardrobePlanner.find('.products-summary'),
	$summaryTemplate = $wardrobePlanner.find('#wardrobe-planner-summary-template'),
	$loadOptions = $step1.find('.load-options'),
	$planToLoad = $loadOptions.find('select#plan-to-load'),
	$saveOptions = $('.save-options'),
	$planTitle = $saveOptions.find('input#plan-title'),
	$customerForm = $wardrobePlanner.find('.ajax-customer-form'),
	$warning = $wardrobePlanner.find('.panel-warning'),
	$login = $customerForm.find('.form-login'),
	$register = $customerForm.find('.form-register'),
	$fullOverlay = $wardrobePlanner.find('.full-overlay'),
	currentStep = 1,
	stepProgress = 1,
	currentProductSelected = null,
	currentProductPrice = null,
	currentProductTarget = null,
	noProductImageUrl = null,
	noProductImageUrl2x = null,
	currentProductImageUrl = null,
	currentProductImageUrl2x = null,
	currentProductProperties = {},
	currentProductID = null,
	currentProduct = null,
	currentVariantID = null,
	currentVariant = null,
	componentWidth = null,
	componentDepth = null,
	componentHeight = null,
	componentDrawers = 0,
	componentShelves = 0,
	componentHandleCount = 0,
	componentType = null,
	towerType = null,
	selectedHeight = null,
	drawersMin = 1,
	drawersMax = 1,
	shelvesMin = 2,
	shelvesMax = 2,
	sidePanelID = $productsList.data('sidepanel'),
	sidePanelProduct = window['product' + sidePanelID],
	backSupportID = $productsList.data('backsupport'),
	backSupportProduct = window['product' + backSupportID],
	fixedShelfID = $productsList.data('fixedshelf'),
	fixedShelfProduct = window['product' + fixedShelfID],
	shelfID = $productsList.data('shelf'),
	shelfProduct = window['product' + shelfID],
	drawerID = $productsList.data('drawer'),
	drawerProduct = window['product' + drawerID],
	drawerHandleID = $productsList.data('drawerwithhandle'),
	drawerHandleProduct = window['product' + drawerHandleID],
	roomWidth = null,
	roomHeight = null,
	defaultRoomWidth = 3600,
	defaultRoomHeight = 2400,
	roomSizeMin = 800,
	roomSizeMax = 8000,
	defaultTowerWidth = 600,
	defaultTowerDepth = 450,
	defaultTowerHeight = 1810,
	drawerHeight = 220,
	maxDrawerHeight = 1400,
	spaceBetweenDrawers = 32,
	drawerDistanceFromFloor = 50,
	spaceBetweenShelves = 150,
	shelfDistanceFromFloor = 200,
	rulerX1Val = 0,
	rulerX2Val = 0,
	rulerX3Val = 0,
	rulerY1Val = 0,
	rulerY2Val = 0,
	rulerY3Val = 0,
	rulerYOffset = 0,
	rulerX1ValNew = 0,
	rulerY1ValNew = 0,
	suggestedRailSupports = 0,
	suggestedShelfSupports = 0,
	suggestedSupportsChanged = false,
	dragInstructions = true,
	progressInstructions = false,
	objectID = 0,
	componentAddedCount = 0,
	componentSelectedCount = 0,
	topPanelAdded = false,
	canvas = new fabric.Canvas('canvas'),
	canvasElement = canvas.getElement(),
	canvasElementW,
	canvasElementH,
	canvasWidth,
	scale,
	resizeTimer,
	defaultSnap = 30,
	snap = defaultSnap,
	sideWidth = 16,
	backSupportHeight = 95,
	cabjaksBlue = '#333333',//'#0084A9',
	lightGrey = '#DFDFDF',
	midGrey = '#B3B3B3',
	darkGrey = '#666666',
	white = '#FFFFFF',
	addtoCartQueue = [],
	finalPrice = 0,
	finalPriceFormatted = null,
	totalHandles = 0,
	handleUpgradeChosen = false,
	handleUpgradeTitle = $handleSelection.data('title'),
	handleUpgradeVariantTitle = $handleSelection.data('varianttitle'),
	handleStyle,
	handleUpgradePrice = $handleUpgradePrice.data('price'),
	totalDrawers = 0,
	softCloseUpgradeChosen = false,
	softCloseStandardChosen = false,
	softCloseID = $softCloseSelection.data('id'),
	softCloseHandleID = $softCloseSelection.data('handleid'),
	softCloseProduct = window['product' + softCloseID],
	softCloseHandleProduct = window['product' + softCloseHandleID],
	softCloseUpgradePrice = softCloseProduct.price - drawerProduct.price,
	firstSave = true,
	savePlanAfterLogin = false,
	addToCartAfterSave = false,
	customerID = options.customer_id,
	planID = options.plan_id,
	customerTags = options.customer_tags,
	planToLoad = 1,
	savedVariables = new Object(),
	saveTimer;
	totalPlan = options.total;
	totalAllowed = 500,
	addToCartCount = 0;
	// edit vars
	isUpdating = false,
	updateLeft = undefined,
	updateTop = undefined,
	notes = [];

	// Add error to field + general step error
	function addError($this, msg) {
		$this.addClass('error').closest('.step').find('.step-error').addClass('shown').html('<p>' + msg + '</p>');
	}

	function addFormError($this, msg) {
		$this.addClass('error').closest('form').find('.form-error').addClass('shown').append('<p>' + msg + '</p>');
	}

	// Remove error from field + remove general step error
	function removeError($this) {
		$this.removeClass('error').closest('.step').find('.step-error').removeClass('shown');
	}

	function validateMeasurement($this) {
		var origVal = $this.val(),
		val = parseInt(origVal, 10);

		// If input was valid
		if(origVal == val && val >= roomSizeMin && val <= roomSizeMax) {
			removeError($this);
			return val;
		} else {
			$this.addClass('error');
			return null;
		}
	}

	function removeMm(val) {
		// If more than one word, use first word
		if(val.indexOf(' ') !== -1) {
			val = val.split(' ');
			val = val[0];
		}

		val = val.replace('mm', '');
		val = parseInt(val, 10);

		return val;
	}

	function validationError(i, $this, msg) {
		window.scrollTo(0, 0);

		if($this.hasClass('.step')) {
			$this.find('.step-error').addClass('shown').html('<p>' + msg + '</p>');
		} else {
			$this.closest('.step').find('.step-error').addClass('shown').html('<p>' + msg + '</p>');
		}

		currentStep = i;

		if(stepProgress > currentStep) {
			updateProgress(currentStep);
		}
	}

	function validateSteps(upTo) {
		for(var i = 1; i <= upTo; i++) {
			// Room size
			if(i == 2) {
				// Validate measurements
				roomWidth = validateMeasurement($roomWidthInput);
				roomHeight = validateMeasurement($roomHeightInput);

				if(roomWidth == null && roomHeight == null) {
					// If both fields are blank, use default measurements
					if($roomWidthInput.val() == "" && $roomHeightInput.val() == "") {
						roomWidth = defaultRoomWidth;
						roomHeight = defaultRoomHeight;

						// Remove errors
						removeError($roomWidthInput);
						removeError($roomHeightInput);

						// Update fields with new values
						$roomWidthInput.val(roomWidth);
						$roomHeightInput.val(roomHeight);
					} else {
						validationError(i, $step1, 'Please make sure your measurements are valid - number only, between ' + roomSizeMin + ' and ' + roomSizeMax + ' millimetres.');
						return false;
					}

				} else if(roomWidth == null) {
					// If width is blank, use default measurement
					if($roomWidthInput.val() == "") {
						roomWidth = defaultRoomWidth;

						// Remove error
						removeError($roomWidthInput);

						// Update field with new value
						$roomWidthInput.val(roomWidth);
					} else {
						validationError(i, $step1, 'Please make sure your room width is valid - number only, between ' + roomSizeMin + ' and ' + roomSizeMax + ' millimetres.');
						return false;
					}

				} else if(roomHeight == null) {
					// If height is blank, use default measurement
					if($roomHeightInput.val() == "") {
						roomHeight = defaultRoomHeight;

						// Remove error
						removeError($roomHeightInput);

						// Update field with new value
						$roomHeightInput.val(roomHeight);
					} else {
						validationError(i, $step1, 'Please make sure your room height is valid - number only, between ' + roomSizeMin + ' and ' + roomSizeMax + ' millimetres.');
						return false;
					}
				}

				// Initialize canvas (now we have room width and height)
				if(currentStep == 2) {
					initCanvas();
				}

			} else if(i == 3 || i == 4) {
				$step2.find('.step-error').removeClass('shown');

				// Layout
				if(i == 3) {
					// Error if no components added
					if(dragInstructions) {
						validationError(i, $step2, 'Please add a tower or component by dragging and dropping from the product list.');
						return false;
					}

					// Warning if no top panel added
					if(!topPanelAdded) {
						topPanelAdded = true;
						$fullOverlay.addClass('shown');
						$warning.addClass('shown');
						return false;
					}
				}
			}
		}
		return true;
	}

	function updateRulers(forceUpdate) {
		var forceUpdate = (typeof forceUpdate === 'undefined') ? false : forceUpdate;

		if(rulerX1ValNew != rulerX1Val || forceUpdate) {
			rulerX1Val = rulerX1ValNew;
			rulerX3Val = roomWidth - rulerX2Val - rulerX1Val;

			$rulerX1.html('<span>' + rulerX1Val + '</span>').css({
				'width': (rulerX1Val/roomWidth * 100).toFixed(2) + '%'
			});

			$rulerX2.css({
				'left': (rulerX1Val/roomWidth * 100).toFixed(2) + '%'
			});

			$rulerX3.html('<span>' + rulerX3Val + '</span>').css({
				'width': (rulerX3Val/roomWidth * 100).toFixed(2) + '%'
			});

			if(rulerX1Val <= 0) {
				$rulerX1.addClass('hidden');
			} else {
				$rulerX1.removeClass('hidden');
			}

			if(rulerX3Val <= 0) {
				$rulerX3.addClass('hidden');
			} else {
				$rulerX3.removeClass('hidden');
			}
		}

		if(rulerY1ValNew != rulerY1Val || forceUpdate) {
			rulerY1Val = rulerY1ValNew;
			rulerY3Val = roomHeight - rulerY2Val - rulerY1Val;

			$rulerY1.html('<span>' + rulerY1Val + '</span>').css({
				'height': (rulerY1Val/roomHeight * 100).toFixed(2) + '%'
			});

			$rulerY2.css({
				'top': (rulerY1Val/roomHeight * 100).toFixed(2) + '%'
			});

			$rulerY3.html('<span>' + rulerY3Val + '</span>').css({
				'height': (rulerY3Val/roomHeight * 100).toFixed(2) + '%'
			});

			if(rulerY1Val <= 0) {
				$rulerY1.addClass('hidden');
			} else {
				$rulerY1.removeClass('hidden');
			}

			if(rulerY3Val <= 0) {
				$rulerY3.addClass('hidden');
			} else {
				$rulerY3.removeClass('hidden');
			}
		}

		$ruler.addClass('shown');
	}

	function updatePrice() {
		finalPrice = 0;

		// Loop through summary items, adding up the price
		for(var i = 0; i < addtoCartQueue.length; i++) {
			finalPrice = finalPrice + addtoCartQueue[i].line_price;
		}

		finalPriceFormatted = Shopify.formatMoney(finalPrice, moneyFormat);

		$progress.find('p.price').html(finalPriceFormatted).parent('.price-info').addClass('shown');
	}

	// Update component summary list
	function updateSummary() {
		// Remove handle upgrades when no handles are required
		if (!(totalHandles > 0)) {
			var removedHandleUpgrade = false;

			for (var i = addtoCartQueue.length - 1; i >= 0; i--) {
				if (addtoCartQueue[i].title === handleUpgradeTitle) {
					addtoCartQueue.splice(i, 1);
					removedHandleUpgrade = true;
				}
			}

			handleUpgradeChosen = false;

			if (removedHandleUpgrade) {
				updatePrice();
			}
		}
		var componentSummary = {
			items: addtoCartQueue,
			subtotal: finalPriceFormatted,
			noimg: noProductImageUrl,
			noimg2x: noProductImageUrl2x
		};

		if($summaryWrapper.length && $summaryTemplate.length) {
			var myTemplate = _.template($.trim($summaryTemplate.text()));
			$summaryWrapper.html(myTemplate(componentSummary));
		}
	}

	function goToNextStep(step) {
		currentStep = step;

		// Update step progress - the only way to move to newer steps is with the next button
		if(currentStep > stepProgress) {
			stepProgress = currentStep;
		}

		updateProgress();
	}

	function goToNextStepAndValidate(step) {
		if(validateSteps(step - 1)) {
			goToNextStep(step);
			// Trigger the hashchange (this usually happens from the button - since we're skipping the button we have to manually do it)
			location.hash = '#step-' + step;
		}
	}

	//show current tab, hide other tabs
	$('.planner-products-list .tabs li .accordion-tab').click(function(e){
		e.preventDefault();
		$(this).toggleClass('active');
		$(this).siblings().slideToggle();
		$(this).find('.accordion-icon-plus, .accordion-icon-minus').toggle();

		$(this).parent('li').siblings().find('.accordion-tab').removeClass('active').siblings().hide();
		$(this).parent('li').siblings().find('.accordion-tab .accordion-icon-plus').show();
		$(this).parent('li').siblings().find('.accordion-tab .accordion-icon-minus').hide();

		//only show scroll message if overflow
		if($(window).width() >= 990){
			if($(this).siblings('.range-content').get(0).scrollHeight > 275){
				$(this).siblings('.scroll-message').show();
			}
			else{
				$(this).siblings('.scroll-message').hide();
			}
		}
	});

	function initNotes(){
        $(".canvas-container").eq(0).imgNotes({
            canEdit: true,
            onEdit: function(ev, elem) {
                var $elem = $(elem);
                $('#NoteDialog').remove();
                return $('<div id="NoteDialog"></div>').dialog({
                    title: "Note Editor",
                    resizable: false,
                    modal: true,
                    height: "217",
                    width: "328",
                    position: { my: "left+20 bottom", at: "right top", of: elem},
                    buttons: {
                        "Save": function() {
                            var txt = $('textarea', this).val();
                            $elem.data("note").note = txt;
                            $(this).dialog("close");
							updateNotesList();
                        },
                        "Delete": function() {
                            $elem.trigger("remove");
                            $(this).dialog("close");
                        },
                        Cancel: function() {
                            $(this).dialog("close");
                        }
                    },
                    open: function() {
                        $(this).css("overflow", "hidden");
						var maxCharacters = 250;
                        var textarea = $(`<textarea id="txt" style="height:100%; width:100%;" maxlength=${maxCharacters}>`);
                        $(this).html(textarea);
                        textarea.val($elem.data("note").note);


						var charRemainingMessage = $('<p class="input-message-label"></p>');
						$(this).append(charRemainingMessage);

						charRemainingMessage.text(maxCharacters - textarea.val().length + ' characters remaining');

						textarea.keyup(function() {
							if (textarea.val().length > maxCharacters ) {
								return false;
							}
							else if (textarea.val().length > 0) {
								charRemainingMessage.text(maxCharacters - textarea.val().length + ' characters remaining');
							}
							else {
								charRemainingMessage.text(maxCharacters + ' characters remaining');
							}
						})
                    }
                });
            }
        });
    }

	function updateProgress() {
		// Scroll to top of page
		window.scrollTo(0, 0);
		resetFrontViewRulers();
		// Unselect products
		onDeselect();

		// Update progress sidebar
		$progress.find('li').removeClass('current').eq(currentStep - 1).addClass('available current').prevAll().addClass('available completed');

		// Allow skipping to review step from layout step
		if(currentStep == 3) {
			$progress.find('li').eq(currentStep).addClass('available');
		}

		// Show/hide steps
		if(currentStep == 1 || currentStep == 2) {
			$wardrobePlanner.find('.step-1').addClass('shown').siblings().removeClass('shown');

			$('.planner-products-summary-section').removeClass('shown');
			//hide planner notes message on sidebar
			$('.planner-notes-message-section').removeClass('shown');

			$productsList.addClass('shown');
			$productsList.removeClass('active');
			$('.action-buttons.save-print').removeClass('shown');

			//hide product list on step 1 in mobile
			if($(window).width() < 990){
				$productsList.removeClass('shown');
				$wardrobePlanner.find('.header-container .nav-toggle').removeClass('shown');

				if($(document.body).hasClass('mob-nav-hide')){
					$(document.body).removeClass('mob-nav-hide');
				}
			}

			//collapse products list accordions
			$productsList.find('.tabs li').removeClass('selected');
			$productsList.find('.tabs li').children('.accordion-tab').removeClass('active').siblings().hide();
			$productsList.find('.tabs li').find('.accordion-tab .accordion-icon-plus').show();
			$productsList.find('.tabs li').find('.accordion-tab .accordion-icon-minus').hide();

			if(currentStep == 1){
				$savedPlan.addClass('shown').siblings('.room-size').removeClass('shown');
			}

			else if(currentStep == 2){
				$savedPlan.removeClass('shown').siblings('.room-size').addClass('shown');
			}

			// hide notes
			$('.notes-viewport').hide();

		// Show/hide sub-steps
		} else if(currentStep == 3 || currentStep == 4 || currentStep == 5) {

			//show save/print buttons
			$('.action-buttons.save-print').addClass('shown');

			if($(window).width() < 990){
				$wardrobePlanner.find('.header-container .nav-toggle').addClass('shown');
			}

			var subStep;

			// Show step 2
			$step2.addClass('shown').siblings().removeClass('shown');

			// Hide old sub-step
			$step2.find('.step').removeClass('shown');

			// Figure out sub-step
			if(currentStep == 3) {
				subStep = '2a';

				// hide notes
				$('.notes-viewport').hide();

			} else if(currentStep == 4) {
				subStep = '2b';

				// Update rulers to show room size
				rulerX2Val = roomWidth;
				rulerY2Val = roomHeight;

				rulerX1ValNew = 0;
				rulerY1ValNew = 0;

				$rulerX2.html('<span>' + rulerX2Val + '</span>').css({
					'width': '100%'
				});

				$rulerY2.html('<span>' + rulerY2Val + '</span>').css({
					'height': '100%'
				});

				updateRulers(true);

				//show planner notes message on sidebar
				$('.planner-notes-message-section').addClass('shown');
				
				//hide products list
				$productsList.removeClass('shown');

				//hide product summary
				$('.planner-products-summary-section').removeClass('shown');

				// notes logic
				initNotes();
				$(".canvas-container").eq(0).imgNotes('import', notes);
				$(".canvas-container").eq(0).imgNotes('fire');
				$('.notes-viewport').show();
				updateNotesList();
			}

			else if(currentStep == 5) {
				subStep = '2c';

				// Update rulers to show room size
				rulerX2Val = roomWidth;
				rulerY2Val = roomHeight;

				rulerX1ValNew = 0;
				rulerY1ValNew = 0;

				$rulerX2.html('<span>' + rulerX2Val + '</span>').css({
					'width': '100%'
				});

				$rulerY2.html('<span>' + rulerY2Val + '</span>').css({
					'height': '100%'
				});

				updateRulers(true);

				renderFrontViewRulers()

				//hide products list
				$productsList.removeClass('shown');

				//hide planner notes message on sidebar
				$('.planner-notes-message-section').removeClass('shown');

				//show product summary
				$('.planner-products-summary-section').addClass('shown');

				// notes logic
				initNotes();
				$(".canvas-container").eq(0).imgNotes('import', notes);
				$(".canvas-container").eq(0).imgNotes('ice');
				$('.notes-viewport').show();

				// preselect standard handle
				if ($handleSelection.find('.choice.selected').length == 0) {
					$handleSelection.find('.choice').first().click();
				}
			}

			// Show new sub-step
			$wardrobePlanner.find('.step-' + subStep).addClass('shown');

			// Lock/unlock components
			canvas.forEachObject(function(obj) {
				if(currentStep == 3) {
					// Unlock all components on review step
					obj.selectable = true;

				} else if(currentStep == 4) {
					// Lock all components on review step
					obj.selectable = false;
				}
			});

			// Update canvas
			canvas.renderAll();
		}

		// Show tips & tricks, products list
		if(currentStep == 3) {
			$tips.addClass('shown');
			$productsList.addClass('shown');


			//open products list accordion
			$productsList.find('.tabs li').addClass('selected');
			$productsList.find('.tabs li').children('.accordion-tab').addClass('active').siblings().show();
			$productsList.find('.tabs li').find('.accordion-tab .accordion-icon-plus').hide();
			$productsList.find('.tabs li').find('.accordion-tab .accordion-icon-minus').show();

			//sidebar product list active
			$productsList.addClass('active');

			//show save/print buttons
			$('.section-header .action-buttons').show();

			//hide product planner summary on sidebar
			$('.planner-products-summary-section').removeClass('shown');

			//margin adjustment for price progress bar if planner has large width and small height
			$step2.find('.price-progress').css({'margin-top': $('.main-planner').height() - $('.planner-content').height() - $('.header-container').height() + 'px'});

		} else {
			$tips.removeClass('shown');
			//$productsList.removeClass('shown');
		}

		// Change 'current price' to 'final price'
		if(currentStep == 4) {
			$progress.find('h3.final-price').addClass('shown').siblings('h3.current-price').removeClass('shown');
		} else if(stepProgress == 4) {
			$progress.find('h3.final-price').removeClass('shown').siblings('h3.current-price').addClass('shown');
		}
	}

	function getCabinetProductTitle(cabinet){
		let title = ''
		if(cabinet.cabjaks.productTitle){
			title = cabinet.cabjaks.productTitle
		}
		else if (typeof window[`product${cabinet.cabjaks.productID}`] != 'undefined'){
			title = window[`product${cabinet.cabjaks.productID}`].title
		}
		
		return title
	}

	function renderFrontViewRulers(){
		const x_bottom_rulers = [];
		const y_right_rulers = [];
		let x_bottom_rulers_html = '';
		let y_right_rulers_html = '';
		let lastBottomCabinetWidth = 0;	
		const x_cabinets = [], y_cabinets = [];
		canvas.forEachObject(function(obj) {
			var objCabinetLayer = obj.cabjaks.layer;
			if(objCabinetLayer == 'Invisible') return;

			const productTitle = getCabinetProductTitle(obj)
			if(productTitle.toLowerCase().includes('tower') || productTitle.toLowerCase().includes('side panel')){
				x_cabinets.push(obj)				
			}
			if(productTitle.toLowerCase().includes('tower') || productTitle.toLowerCase().includes('top')){
				y_cabinets.push(obj)				
			}
		})
		x_cabinets.sort(function(a, b){
			return a.getLeft() - b.getLeft()
		})
		y_cabinets.sort(function(a, b){
			return a.getTop() - b.getTop()
		})

		x_cabinets.forEach(function(cabinet, index){
			x_bottom_rulers.push(cabinet.getLeft());
			lastBottomCabinetWidth = cabinet.width;
			const cabinetWidth = cabinet.width + 1;
			if(index < x_cabinets.length - 1 && x_cabinets[index + 1].getLeft() - cabinet.getLeft() > cabinetWidth){
				x_bottom_rulers.push(cabinet.getLeft() + cabinetWidth)
			}		
		})
		let lastTopCabinetHeight = 0;
		y_cabinets.forEach(function(cabinet, index){	
			y_right_rulers.push(cabinet.getTop());
			lastTopCabinetHeight = cabinet.height;
			const cabinetHeight = cabinet.height + 1;
			if(index < y_cabinets.length - 1 && y_cabinets[index + 1].getTop() - cabinet.getTop() > cabinetHeight){
				y_right_rulers.push(cabinet.getTop() + cabinetHeight)
			}
		})

		x_bottom_rulers.push(Math.round(x_bottom_rulers[x_bottom_rulers.length - 1] + lastBottomCabinetWidth + 1))
		x_bottom_rulers.push(Math.round(roomWidth))
		x_bottom_rulers.forEach(function(x, i){
			let rulerWidth = x;
			if(i > 0){
				rulerWidth = x - x_bottom_rulers[i-1];
			}
			if(rulerWidth > 1){
				rulerWidth = Math.round(rulerWidth)
				x_bottom_rulers_html += `<div class="ruler-value" style="width: ${rulerWidth/roomWidth * 100}%;"><span class="${rulerWidth < 100 ? "narrow" : ""}">${rulerWidth}</span></div>`			
			}
		})

		y_right_rulers.push(Math.round(y_right_rulers[y_right_rulers.length - 1] + lastTopCabinetHeight + 1))
		y_right_rulers.push(Math.round(roomHeight))
		y_right_rulers.sort(function(a, b){return a - b})
		y_right_rulers.forEach(function(y, i){
			let rulerHeight = y
			if(i > 0){
				rulerHeight = y - y_right_rulers[i-1]
			}
			if(rulerHeight > 1){
				rulerHeight = Math.round(rulerHeight)
				y_right_rulers_html += `<div class="ruler-value" style="height: ${rulerHeight/roomHeight * 100}%;"><span class="${rulerHeight < 100 ? "narrow" : ""}">${Math.round(rulerHeight)}</span></div>`						
			}
		})
		if(y_right_rulers.length > 0){
			y_right_rulers_html += `<div class="ruler-value gap last-gap" style="height: 0"></div>`
		}
		
		$(`.diagram .ruler-x-bottom`).html(x_bottom_rulers_html)
		$(`.diagram .ruler-y-right`).html(y_right_rulers_html)
	}
	
	function resetFrontViewRulers(){
		$(`.diagram .ruler-x-bottom`).html('')
		$(`.diagram .ruler-y-right`).html('')
	}	
/*UPDATE START 28 OCT*/
	// Add the complete wardrobe plan in one request
	function ajaxAddtoCart() {
		// Prevent overlapping submissions
		if (ajaxAddtoCart.isRunning) return;

		var items = addtoCartQueue
			.filter(function(item) {
				return item.quantity > 0;
			})
			.map(function(item) {
				// Copy properties without modifying the saved plan
				var properties = $.extend({}, item.properties || {});
				var title = item.title || '';

				// Preserve the existing property rules
				if (softCloseUpgradeChosen) {
					if (item.soft_close_drawers) {
						properties['Drawer Type'] = 'Soft Close';
					}
				} else if (typeof properties['Hinge Type'] !== 'undefined') {
					properties['Hinge Type'] = 'Standard';
				} else {
					if (
						!title.toLowerCase().includes('soft close') &&
						!title.toLowerCase().includes('upgrade') &&
						!title.includes('Hanging Rail') &&
						!title.includes('Hanging Rail Wall Support (Pair)') &&
						!title.includes('Shelf Supports') &&
						!title.includes('Corner Support') &&
						!title.includes('Hanging Rail Centre Support') &&
						!title.includes('Hanging Rail Blind End Support')
					) {
						properties['_Colour'] = 'White';
					}
				}

				return {
					id: item.id,
					quantity: item.quantity,
					properties: properties
				};
			});

		var $buttons = $wardrobePlanner.find('button.add-to-cart');

		if (!items.length) {
			$buttons.prop('disabled', false).removeClass('is-adding');
			return;
		}

		var root = window.Shopify && Shopify.routes
			? Shopify.routes.root
			: '/';

		ajaxAddtoCart.isRunning = true;
		$buttons.prop('disabled', true).addClass('is-adding');

		$.ajax({
			type: 'POST',
			url: root + 'cart/add.js',
			contentType: 'application/json',
			dataType: 'json',
			data: JSON.stringify({ items: items })
		}).done(function() {
			// Items have been added successfully
			window.onbeforeunload = null;

			// Finish updating cart attributes before opening the drawer
			$.ajax({
				type: 'POST',
				url: root + 'cart/update.js',
				contentType: 'application/json',
				dataType: 'json',
				data: JSON.stringify({
					attributes: {
						cart_plan_type: 'wardrobe'
					}
				})
			}).fail(function() {
				alert(
					'Your items were added, but the cart plan type could not be updated. ' +
					'Please check your cart before continuing.'
				);
			}).always(function() {
				finishAdding();
				$('.js-drawer-open-right').click();
			});
		}).fail(function(xhr) {
			var response = xhr.responseJSON || {};
			var message = response.description || response.message ||
				'Unable to add the plan.';

			finishAdding();

			alert(
				message +
				'\nPlease check your cart before retrying.'
			);
		});

		function finishAdding() {
			ajaxAddtoCart.isRunning = false;
			addToCartCount = 0;
			$buttons.prop('disabled', false).removeClass('is-adding');
		}
	}
/*UPDATE END 28 OCT*/
	// Set up canvas for new plan
	function createNewPlan() {
		// Show room size step
		$savedPlan.removeClass('shown').siblings('.room-size').addClass('shown');

		// Go to room size step
		goToNextStepAndValidate(2);

		// Scroll to top of page
		window.scrollTo(0, 0);

		canvas.setBackgroundColor(cabjaksBlue);
	}

	// Initialize canvas
	function initCanvas() {
		canvasWidth = $heading.width(); // Using heading because it's always visible - sometimes the canvas step is hidden
		if($(window).width() > 768){
			canvasWidth = $heading.width() * 0.7;
		}
		scale = canvasWidth / roomWidth;
		canvas.setZoom(scale);
		canvas.setWidth(roomWidth * scale);
		canvas.setHeight(roomHeight * scale);
		canvas.setBackgroundColor(cabjaksBlue);

		// Fix for retina devices
		if(window.devicePixelRatio !== 1) {
			canvasElementW = canvasElement.width;
			canvasElementH = canvasElement.height;

			// Scale the canvas up
			canvasElement.setAttribute('width', canvasElementW * window.devicePixelRatio);
			canvasElement.setAttribute('height', canvasElementH * window.devicePixelRatio);

			// Set the scale of the context
			canvasElement.getContext('2d').scale(window.devicePixelRatio, window.devicePixelRatio);
		}

		canvas.renderAll();
	}

	function initAutoLoad() {
		const uuid = new URLSearchParams(window.location.search).get('plan-id');
		if(uuid) {
			planToLoad = uuid;
			// $fullOverlay.addClass('shown');
			// $loadOptions.addClass('shown');

			loadSavedPlan();
		}
		return;
	}

	function findPlanToLoad() {
		// If there's more than one plan
		if(planID > 2) {
			// Show plans popup
			$fullOverlay.addClass('shown');
			$loadOptions.addClass('shown');

		// One saved plan
		} else if(planID == 2) {
			planToLoad = 1;

			// Show loading popup
			$fullOverlay.addClass('shown');
			$loadOptions.addClass('shown');

			loadSavedPlan();

		// No saved plans
		} else {
			// Show plans popup
			$fullOverlay.addClass('shown');
			$loadOptions.addClass('shown');

			// Show no plans message
			$loadOptions.find('.step-form').removeClass('shown').siblings('.step-no-plans').addClass('shown');

			clearTimeout(saveTimer);
			saveTimer = setTimeout(function() {
				// Close popup
				$fullOverlay.removeClass('shown');
				$loadOptions.removeClass('shown').find('.step-no-plans').removeClass('shown').siblings('.step-form').addClass('shown');

				// Create new plan
				createNewPlan();
			}, 3000);
		}
	}

	// Validate cart queue against plan data
	// Find a product variant by matching tower dimensions (same matching rules
	// as the tower part lookup in createComponent). Pass null for a dimension
	// that shouldn't be matched.
	function findTowerPartVariant(product, matchWidthVal, matchDepthVal, matchHeightVal) {
		if (!product || !product.variants || !product.variants.length) {
			return null;
		}

		for (var i = 0; i < product.variants.length; i++) {
			var found = true;

			for (var j = 0; j < product.options.length; j++) {
				var optionValue = removeMm(product.variants[i]['option' + (j + 1)]);

				if (product.options[j] == 'Width' && matchWidthVal != null && matchWidthVal != optionValue) {
					found = false;
				} else if (product.options[j] == 'Depth' && matchDepthVal != null && matchDepthVal != optionValue) {
					found = false;
				} else if (product.options[j] == 'Height' && matchHeightVal != null && matchHeightVal != optionValue) {
					found = false;
				}
			}

			if (found) {
				return product.variants[i];
			}
		}

		return null;
	}

	function validateCartQueueAgainstPlan() {
		if (!addtoCartQueue || addtoCartQueue.length === 0) {
			return;
		}
		var originalCartQueue = JSON.parse(JSON.stringify(addtoCartQueue));

		// Get only panel and rail items from the canvas
		var planPanelRailItems = [];
		canvas.forEachObject(function(obj) {
			// Only include panels and rails, skip invisible objects
			if (!obj.cabjaks || obj.cabjaks.layer === 'Invisible') return;
			
			// Check if this is a panel or rail by layer or product type
			var isPanelOrRail = obj.cabjaks.layer === 'Panel' || 
							   obj.cabjaks.layer === 'Rail' ||
							   (obj.cabjaks.productTitle && (
								   obj.cabjaks.productTitle.toLowerCase().includes('panel') ||
								   obj.cabjaks.productTitle.toLowerCase().includes('rail')
							   )) || 
							   (window[`product${obj.cabjaks.productID}`] &&
								(window[`product${obj.cabjaks.productID}`].title.toLowerCase().includes('panel') || window[`product${obj.cabjaks.productID}`].title.toLowerCase().includes('rail'))
								);
							   
			
			if (!isPanelOrRail) return;
			
			var itemData = {
				variantID: obj.cabjaks.variantID,
				productID: obj.cabjaks.productID,
				properties: obj.cabjaks.properties || {},
				title: obj.cabjaks.productTitle || '',
				objectID: obj.cabjaks.id,
				layer: obj.cabjaks.layer
			};
			
			planPanelRailItems.push(itemData);
		});

		// Also check subProducts within tower components for panels/rails
		canvas.forEachObject(function(obj) {
			// Only check objects with cabjaks and subProducts (typically Towers)
			if (!obj.cabjaks || !obj.cabjaks.subProducts || !Array.isArray(obj.cabjaks.subProducts)) {
				return;
			}

			// Loop through subProducts
			for (var k = 0; k < obj.cabjaks.subProducts.length; k++) {
				var subProduct = obj.cabjaks.subProducts[k];
				
				// Look up this subProduct in originalCartQueue to get its title
				var matchingCartItem = null;
				for (var m = 0; m < originalCartQueue.length; m++) {
					if (
						originalCartQueue[m].isAdditionalComponent !== true &&
						originalCartQueue[m].id === subProduct.id
					) {
						// Also check if properties match
						var cartProps = JSON.stringify(originalCartQueue[m].properties || {});
						var subProps = JSON.stringify(subProduct.properties || {});
						if (cartProps === subProps) {
							matchingCartItem = originalCartQueue[m];
							break;
						}
					}
				}
				if (matchingCartItem && matchingCartItem.title) {
					var isSubProductPanelOrRail = matchingCartItem.title.toLowerCase().includes('panel') ||
												   matchingCartItem.title.toLowerCase().includes('rail');

					if (isSubProductPanelOrRail) {
						for (var q = 0; q < subProduct.quantity; q++) {
							var subProductItemData = {
								variantID: subProduct.id,
								productID: null,
								properties: subProduct.properties || {},
								title: matchingCartItem.title,
								objectID: obj.cabjaks.id,
								layer: null
							};
							planPanelRailItems.push(subProductItemData);
						}
					}
				}
			}
		});

		// Re-derive the required side panels and back support panel for every tower
		// from its dimensions (CAB-493). Historical saved plans can be missing these
		// from both the cart queue and the tower's subProducts, so they can't be
		// recovered from the saved data above — rebuild them from the tower's
		// componentOptions and the current product data instead.
		canvas.forEachObject(function(obj) {
			if (!obj.cabjaks || obj.cabjaks.componentType !== 'Towers' || !obj.cabjaks.componentOptions) {
				return;
			}

			var towerWidth = obj.cabjaks.componentOptions[0],
			towerDepth = obj.cabjaks.componentOptions[1],
			towerHeight = obj.cabjaks.componentOptions[2],
			requiredTowerParts = [
				{
					// 2x drilled side panels — match tower depth and height
					product: sidePanelProduct,
					quantity: 2,
					matchWidth: null,
					matchDepth: towerDepth,
					matchHeight: towerHeight,
					info: [
						{ title: 'Width', value: sideWidth + 'mm' },
						{ title: 'Depth', value: towerDepth + 'mm' },
						{ title: 'Height', value: towerHeight + 'mm' }
					]
				},
				{
					// 1x back support panel — match tower width
					product: backSupportProduct,
					quantity: 1,
					matchWidth: towerWidth,
					matchDepth: null,
					matchHeight: null,
					info: [
						{ title: 'Width', value: towerWidth + 'mm' }
					]
				}
			];

			for (var p = 0; p < requiredTowerParts.length; p++) {
				var requiredPart = requiredTowerParts[p];

				if (!requiredPart.product) {
					continue;
				}

				var partVariant = findTowerPartVariant(requiredPart.product, requiredPart.matchWidth, requiredPart.matchDepth, requiredPart.matchHeight);

				if (!partVariant) {
					console.warn('Could not match a ' + requiredPart.product.title + ' variant for tower', obj.cabjaks.id, obj.cabjaks.componentOptions);
					continue;
				}

				// Count what the subProducts pass above already recorded for this tower
				var alreadyCounted = 0;
				for (var q = 0; q < planPanelRailItems.length; q++) {
					if (planPanelRailItems[q].objectID === obj.cabjaks.id && planPanelRailItems[q].variantID == partVariant.id) {
						alreadyCounted++;
					}
				}

				// Top up the plan items so the phases below restore the missing units
				for (var r = alreadyCounted; r < requiredPart.quantity; r++) {
					planPanelRailItems.push({
						variantID: partVariant.id,
						productID: requiredPart.product.id,
						properties: {},
						title: requiredPart.product.title.replace('Wardrobe ', ''),
						objectID: obj.cabjaks.id,
						layer: null,
						towerPartProduct: requiredPart.product,
						towerPartVariant: partVariant,
						towerPartInfo: requiredPart.info
					});
				}

				// Keep the tower's subProducts consistent so deleting it later
				// removes the right quantities from the cart queue
				if (!obj.cabjaks.subProducts) {
					obj.cabjaks.subProducts = [];
				}

				var subProductEntry = null;
				for (var s = 0; s < obj.cabjaks.subProducts.length; s++) {
					if (obj.cabjaks.subProducts[s].id == partVariant.id && JSON.stringify(obj.cabjaks.subProducts[s].properties || {}) === '{}') {
						subProductEntry = obj.cabjaks.subProducts[s];
						break;
					}
				}

				if (!subProductEntry) {
					obj.cabjaks.subProducts.push({
						id: partVariant.id,
						quantity: requiredPart.quantity,
						properties: {}
					});
					obj.cabjaks.price = (obj.cabjaks.price || 0) + (partVariant.price * requiredPart.quantity);
				} else if (subProductEntry.quantity < requiredPart.quantity) {
					obj.cabjaks.price = (obj.cabjaks.price || 0) + (partVariant.price * (requiredPart.quantity - subProductEntry.quantity));
					subProductEntry.quantity = requiredPart.quantity;
				}
			}
		});

		// First, count quantities for each variant ID + properties combination in the plan
		var planItemCounts = {};
		for (var i = 0; i < planPanelRailItems.length; i++) {
			var planItem = planPanelRailItems[i];
			var countKey = planItem.variantID + '_' + JSON.stringify(planItem.properties);
			planItemCounts[countKey] = (planItemCounts[countKey] || 0) + 1;
		}

		// Filter the cart queue to keep only items that match the plan or are non-panel/rail items
		var validatedQueue = [];
		
		for (var i = 0; i < addtoCartQueue.length; i++) {
			var cartItem = addtoCartQueue[i];

			// Preserve manually selected extras
			if (cartItem.isAdditionalComponent === true) {
				validatedQueue.push(cartItem);
				continue;
			}

			var isValidPanelRail = false;
			var correctQuantity = 0;
			
			// Check if this cart item is a panel or rail
			var isPanelRailCartItem = cartItem.title && (
				cartItem.title.toLowerCase().includes('panel') ||
				(cartItem.title.toLowerCase().includes('rail') && !cartItem.title.toLowerCase().includes('support'))
			);
			
			if (isPanelRailCartItem) {
				// Check if this cart item matches any panel/rail in the plan
				for (var j = 0; j < planPanelRailItems.length; j++) {
					var planItem = planPanelRailItems[j];
					
					// Match by variant ID and properties
					if (cartItem.id === planItem.variantID) {
						// For panels/rails, also check if properties match		
						if (JSON.stringify(cartItem.properties) !== JSON.stringify(planItem.properties)) {
							continue; // Skip this item if properties don't match
						}
						isValidPanelRail = true;
						
						// Get the correct quantity from plan
						var countKey = planItem.variantID + '_' + JSON.stringify(planItem.properties);
						correctQuantity = planItemCounts[countKey];
						break;					
					}
				}
				
				if (isValidPanelRail) {
					// Update quantity if it doesn't match the plan
					if (cartItem.quantity !== correctQuantity) {
						cartItem.quantity = correctQuantity;
						cartItem.line_price = cartItem.price * correctQuantity;
						cartItem.line_price_formatted = Shopify.formatMoney(cartItem.line_price, moneyFormat);
						console.log('Updated panel/rail cart item quantity:', cartItem.title, 'New quantity:', correctQuantity);
					}
					validatedQueue.push(cartItem);
				} else {
					console.log('Removing invalid panel/rail cart item:', cartItem.title, 'Variant ID:', cartItem.id);
				}
			} else {
				// Keep all non-panel/rail items (cabinets, upgrades, etc.) without validation
				validatedQueue.push(cartItem);
			}
		}
		
		// Update the cart queue with validated items
		addtoCartQueue = validatedQueue;
		
		// Count hanging rails in the plan to validate wall support quantity
		var hangingRailCount = 0;
		canvas.forEachObject(function(obj) {
			if (obj.cabjaks && (
				obj.cabjaks.productTitle === 'Hanging Rail' ||
				(window[`product${obj.cabjaks.productID}`] &&
					(window[`product${obj.cabjaks.productID}`].title.toLowerCase().includes('hanging rail'))
				))
			) {
				hangingRailCount++;
			}
		});
		
		// Find and update Hanging Rail Wall Support (Pair) quantity
		for (var i = 0; i < addtoCartQueue.length; i++) {
			var cartItem = addtoCartQueue[i];
			if (
				cartItem.isAdditionalComponent !== true &&
				cartItem.title === 'Hanging Rail Wall Support (Pair)'
			) {
				if (cartItem.quantity < hangingRailCount) {
					cartItem.quantity = hangingRailCount;
					cartItem.line_price = cartItem.price * hangingRailCount;
					cartItem.line_price_formatted = Shopify.formatMoney(cartItem.line_price, moneyFormat);
					console.log('Updated Hanging Rail Wall Support quantity to match hanging rails:', hangingRailCount);
				}
				break;
			}
		}
		
		// Group plan panel/rail items by variant ID and properties to calculate correct quantities
		var planItemGroups = {};
		for(var i=0; i<planPanelRailItems.length; i++) {
			var planItem = planPanelRailItems[i];
			var groupKey = planItem.variantID + '_' + JSON.stringify(planItem.properties);
			
			if (!planItemGroups[groupKey]) {
				planItemGroups[groupKey] = {
					planItem: planItem,
					quantity: 0
				};
			} else if (planItem.towerPartProduct && !planItemGroups[groupKey].planItem.towerPartProduct) {
				// Prefer the re-derived tower part item — it carries the product
				// data needed to rebuild a missing cart line from scratch
				planItemGroups[groupKey].planItem = planItem;
			}
			planItemGroups[groupKey].quantity++;
		}
		
		// Add missing panel/rail items or update quantities for existing items
		for (var groupKey in planItemGroups) {
			var group = planItemGroups[groupKey];
			var planItem = group.planItem;
			var requiredQuantity = group.quantity;
			
			// Check if item already exists in cart queue
			var existingCartItem = addtoCartQueue.find(item =>
				item.isAdditionalComponent !== true &&
				item.id === planItem.variantID &&
				JSON.stringify(item.properties) === JSON.stringify(planItem.properties)
			);
			
			if (existingCartItem) {
				// Update quantity if it's different
				if (existingCartItem.quantity !== requiredQuantity) {
					existingCartItem.quantity = requiredQuantity;
					existingCartItem.line_price = existingCartItem.price * requiredQuantity;
					existingCartItem.line_price_formatted = Shopify.formatMoney(existingCartItem.line_price, moneyFormat);
					console.log('Updated quantity for panel/rail cart item:', existingCartItem.title, 'New quantity:', requiredQuantity);
				}
			} else {
				// Re-derived tower part — rebuild the cart line from product data,
				// since the saved plan has no record of it to copy from
				if (planItem.towerPartProduct && planItem.towerPartVariant) {
					var towerPartVariant = planItem.towerPartVariant,
					towerPartImage = noProductImageUrl,
					towerPartImage2x = noProductImageUrl2x;

					if (planItem.towerPartProduct.featured_image) {
						towerPartImage = Shopify.Image.getSizedImageUrl(planItem.towerPartProduct.featured_image, 'medium');
						towerPartImage2x = Shopify.Image.getSizedImageUrl(planItem.towerPartProduct.featured_image, 'large') + ' 2x';
					}

					addtoCartQueue.push({
						id: towerPartVariant.id,
						title: planItem.title,
						quantity: requiredQuantity,
						price: towerPartVariant.price,
						price_formatted: Shopify.formatMoney(towerPartVariant.price, moneyFormat),
						line_price: towerPartVariant.price * requiredQuantity,
						line_price_formatted: Shopify.formatMoney(towerPartVariant.price * requiredQuantity, moneyFormat),
						img: towerPartImage,
						img2x: towerPartImage2x,
						info: planItem.towerPartInfo || [],
						properties: planItem.properties || {},
						soft_close_drawers: false,
						soft_close_hinges: false
					});
					console.log('Restored missing tower part to cart:', planItem.title, 'Variant ID:', towerPartVariant.id, 'Quantity:', requiredQuantity);

				// Check if this is a subProduct (productID is null) or a direct canvas object
				} else if (planItem.productID === null) {
					var subProductCartItem = null;
					for (var n = 0; n < originalCartQueue.length; n++) {
						if (
							originalCartQueue[n].isAdditionalComponent !== true &&
							originalCartQueue[n].id === planItem.variantID
						) {
							var cartProps = JSON.stringify(originalCartQueue[n].properties || {});
							var planProps = JSON.stringify(planItem.properties || {});
							if (cartProps === planProps) {
								subProductCartItem = originalCartQueue[n];
								break;
							}
						}
					}

					if (subProductCartItem) {
						var cartItem = {
							id: subProductCartItem.id,
							title: subProductCartItem.title,
							quantity: requiredQuantity,
							price: subProductCartItem.price,
							price_formatted: Shopify.formatMoney(subProductCartItem.price, moneyFormat),
							line_price: subProductCartItem.price * requiredQuantity,
							line_price_formatted: Shopify.formatMoney(subProductCartItem.price * requiredQuantity, moneyFormat),
							img: subProductCartItem.img,
							img2x: subProductCartItem.img2x,
							info: subProductCartItem.info || [],
							properties: subProductCartItem.properties || {},
							soft_close_drawers: subProductCartItem.soft_close_drawers || false,
							soft_close_hinges: subProductCartItem.soft_close_hinges || false
						};
						
						addtoCartQueue.push(cartItem);
						console.log('Added missing panel/rail subProduct item to cart:', cartItem.title, 'Variant ID:', cartItem.id, 'Quantity:', requiredQuantity);
					}
				} else {
					// This is a direct canvas object - find it and get product data
					canvas.forEachObject(function(obj) {
						if (obj.cabjaks && obj.cabjaks.id === planItem.objectID) {
							// Create properly formatted cart item
							var cartItem = {
								id: obj.cabjaks.variantID,
								title: obj.cabjaks.productTitle,
								quantity: requiredQuantity,
								price: obj.cabjaks.price,
								price_formatted: Shopify.formatMoney(obj.cabjaks.price, moneyFormat),
								line_price: obj.cabjaks.price * requiredQuantity,
								line_price_formatted: Shopify.formatMoney(obj.cabjaks.price * requiredQuantity, moneyFormat),
								img: obj.cabjaks.image,
								img2x: obj.cabjaks.image2x,
								info: obj.cabjaks.info || [],
								properties: obj.cabjaks.properties || {},
								soft_close_drawers: obj.cabjaks.drawersSmall > 0 || obj.cabjaks.drawersLarge > 0,
								soft_close_hinges: obj.cabjaks.hinges > 0
							};
							
							addtoCartQueue.push(cartItem);
							console.log('Added missing panel/rail item to cart:', cartItem.title, 'Variant ID:', cartItem.id, 'Quantity:', requiredQuantity);
						}
					});
				}
			}
		}
		
		console.log('Cart queue validation complete. Items after validation:', addtoCartQueue.length);
	}


	// Load plan from DB
	function loadSavedPlan(multiplePlans) {
		var multiplePlans = (typeof multiplePlans === 'undefined') ? false : multiplePlans,
		$allChoices = $savedPlan.find('.products-list');

		$allChoices.addClass('is-loading');

		// Show loader
		$loadOptions.find('.step-form').removeClass('shown').siblings('.step-loading').addClass('shown');

		const cid = new URLSearchParams(window.location.search).get('cid');
		// Per-plan share token from the share URL; forwarded so the backend can
		// authorise a public load of a plan that isn't in the showcase allowlist.
		const shareToken = new URLSearchParams(window.location.search).get('token');
		// Load plan from DB
		$.ajax({
			method: 'POST',
			url: planner_api_url + '/planner/load',
			data: JSON.stringify(Object.assign({
				plan_type: 'wardrobe',
				customer_id: cid ? `${cid}__public` : customerID,
				plan_id: planToLoad
			}, (cid && shareToken) ? { share_token: shareToken } : {})),
			timeout: 15000,
			cache: false,
			contentType: "application/json"
		}).done(function(resultJSON) {
			var result = resultJSON;
			if(result.response === 'Success') {
				// Load variables
				var loadedVariables = result.variables;

				if(loadedVariables) {
					// On save, do update not insert
					firstSave = false;
					if(cid && cid != customerID){
						firstSave = true
					}
					// Update plan ID to the loaded plan
					if(!cid){
						// Update plan ID to the loaded plan
						planID = planToLoad;
					}					
					// Load plan
					canvas.loadFromJSON(result.plan);

					// Convert JSON string to object
					loadedVariables = $.parseJSON(loadedVariables);

					// Update variables with loaded values
					stepProgress = loadedVariables.stepProgress;
					roomWidth = loadedVariables.roomWidth;
					roomHeight = loadedVariables.roomHeight;
					suggestedRailSupports = loadedVariables.suggestedRailSupports;
					suggestedShelfSupports = loadedVariables.suggestedShelfSupports;
					suggestedSupportsChanged = loadedVariables.suggestedSupportsChanged;
					dragInstructions = loadedVariables.dragInstructions;
					progressInstructions = loadedVariables.progressInstructions;
					objectID = loadedVariables.objectID;
					componentAddedCount = loadedVariables.componentAddedCount;
					componentSelectedCount = loadedVariables.componentSelectedCount;
					topPanelAdded = loadedVariables.topPanelAdded;
					addtoCartQueue = loadedVariables.addtoCartQueue;
					finalPrice = loadedVariables.finalPrice;
					finalPriceFormatted = loadedVariables.finalPriceFormatted;
					totalHandles = loadedVariables.totalHandles;
					handleUpgradeChosen = loadedVariables.handleUpgradeChosen;
					handleStyle = loadedVariables.handleStyle;
					totalDrawers = loadedVariables.totalDrawers;
					softCloseUpgradeChosen = loadedVariables.softCloseUpgradeChosen;
					softCloseStandardChosen = loadedVariables.softCloseStandardChosen;
					// Notes Var
					notes = loadedVariables.notes || [];

					validateCartQueueAgainstPlan();

					// Setting room size
					$roomWidthInput.val(roomWidth);
					$roomHeightInput.val(roomHeight);

					// Make all steps available
					$progress.find('li').addClass('available');

					// Show price
					$progress.find('p.price').html(finalPriceFormatted).parent('.price-info').addClass('shown');

					// Hide instructions/tips shown already
					$dragInstructions.removeClass('shown');

					if(!progressInstructions) {
						// Show default tip
						$tips.find('.tip-3').addClass('shown').siblings().removeClass('shown');
					} else {
						// Show progress tip
						$tips.find('.tip-4').addClass('shown').siblings().removeClass('shown');
					}

					// Clear existing quantities before restoring the saved plan
					$additionalComponents.find('input[name=quantity]').val(0);

					// Restore additional components
					for (var i = 0; i < addtoCartQueue.length; i++) {
						var savedComponent = addtoCartQueue[i];

						$additionalComponents.find('.cart__row').each(function() {
							var $this = $(this);
							var rowVariantID = $this.attr('data-variant-id');
							var $title = $this.find('.h4').text().trim();
							var $quantity = $this.find('input[name=quantity]');

							// Extras: match the exact variant
							if (rowVariantID) {
								if (String(rowVariantID) !== String(savedComponent.id)) {
									return;
								}

								// A tower's included back panel must not populate the extra selector
								var isBackSupportVariant = backSupportProduct &&
									backSupportProduct.variants.some(function(variant) {
										return String(variant.id) === String(rowVariantID);
									});

								if (
									isBackSupportVariant &&
									savedComponent.isAdditionalComponent !== true
								) {
									return;
								}

								$quantity.val(savedComponent.quantity);
								return false;
							}

							// Supports: retain the existing title/dropdown behaviour
							if ($title === savedComponent.title) {
								$quantity.val(savedComponent.quantity);

								if (savedComponent.info && savedComponent.info.length) {
									$this.find('select.variant-selector option').each(function() {
										var $option = $(this);

										if (
											$option.text().indexOf(
												savedComponent.info[0].value
											) > -1
										) {
											$option.prop('selected', true);
										}
									});

									$this.find('p.price').html(savedComponent.price_formatted);
								}

								return false;
							}
						});
					}

					// Show handle choice
					if(totalHandles > 0) {
						$handleSelection.addClass('shown');

						// Update handle upgrade price
						$handleUpgradePrice.each(function() {
							$(this).html(Shopify.formatMoney(($(this).data('price')) * totalHandles));
						})
					}

					// Select handle style
					if(handleStyle) {
						$handleSelection.find('.choice').each(function() {
							if($(this).find('h3').text() == handleStyle) {
								$(this).addClass('selected');

								//remove select for default included handle
								$(this).parent('.grid__item').siblings().children('.choice.included').removeClass('selected');
								return false;
							}
						});
					}

					// Show soft close upgrade
					if(totalDrawers > 0) {
						$softCloseSelection.addClass('shown');

						// Update soft close price
						$softClosePrice.html(Shopify.formatMoney(softCloseUpgradePrice * totalDrawers));
					}

					// Select soft close chosen
					if(softCloseUpgradeChosen) {
						$softCloseSelection.find('.choice').each(function() {
							if($(this).find('h3').text().indexOf("Standard") === -1) {
								$(this).addClass('selected');

								//remove select for default included soft close
								$(this).parent('.grid__item').siblings().children('.choice.included').removeClass('selected');
								return false;
							}
						});
					}

					// Select soft close standard
					if(softCloseStandardChosen) {
						$softCloseSelection.find('.choice').each(function() {
							if($(this).find('h3').text().indexOf("Standard") > -1) {
								$(this).addClass('selected');
								return false;
							}
						});
					}

					// show saved planner name
					if(!cid){
						const planners = $('[data-planners]').data('planners')
						$('[data-planners]').html(`(${planners[`plan${planID}_title`]})`)
					}

					updatePrice();
					// Update summary list
					updateSummary();

					// Close popup
					$fullOverlay.removeClass('shown');
					$loadOptions.removeClass('shown');

					// Show room size step
					$savedPlan.removeClass('shown').siblings('.room-size').addClass('shown');

					// Go to layout step
					goToNextStepAndValidate(cid ? 4 : 3);

					initCanvas();

				} else {
					alert('Error with loaded plan.');
				}

			} else {
				alert('Could not load plan. Please try again. (' + result.msg + '.)');
			}
		}).fail(function() {
			alert('Could not load plan. Please try again. (AJAX error.)');

			// If only one plan, hide popup
			if(!multiplePlans) {
				// Unselect
				$savedPlan.find('.choice').removeClass('selected');

				// Close popup
				$fullOverlay.removeClass('shown');
				$loadOptions.removeClass('shown');
			}
		}).always(function() {
			$allChoices.removeClass('is-loading');

			// Go back to form
			$loadOptions.find('.step-loading').removeClass('shown').siblings('.step-form').addClass('shown');
		});
	}

	function savePlan() {
		savedVariables.stepProgress = stepProgress;
		savedVariables.roomWidth = roomWidth;
		savedVariables.roomHeight = roomHeight;
		savedVariables.suggestedRailSupports = suggestedRailSupports;
		savedVariables.suggestedShelfSupports = suggestedShelfSupports;
		savedVariables.suggestedSupportsChanged = suggestedSupportsChanged;
		savedVariables.dragInstructions = dragInstructions;
		savedVariables.progressInstructions = progressInstructions;
		savedVariables.objectID = objectID;
		savedVariables.componentAddedCount = componentAddedCount;
		savedVariables.componentSelectedCount = componentSelectedCount;
		savedVariables.topPanelAdded = topPanelAdded;
		savedVariables.addtoCartQueue = addtoCartQueue;
		savedVariables.finalPrice = finalPrice;
		savedVariables.finalPriceFormatted = finalPriceFormatted;
		savedVariables.totalHandles = totalHandles;
		savedVariables.handleUpgradeChosen = handleUpgradeChosen;
		savedVariables.handleStyle = handleStyle;
		savedVariables.totalDrawers = totalDrawers;
		savedVariables.softCloseUpgradeChosen = softCloseUpgradeChosen;
		savedVariables.softCloseStandardChosen = softCloseStandardChosen;
		// save notes
		initNotes();
		savedVariables.notes = $(".canvas-container").eq(0).imgNotes('export');
		if(currentStep != 4){
			$('.notes-viewport').hide();
		}

		if(firstSave) {
			// Show title popup
			$fullOverlay.addClass('shown');
			$saveOptions.addClass('shown');

		// Update existing plan
		} else {

			if (canvas._objects.length <= 1) {
				savedVariables.addtoCartQueue = [];
				savedVariables.finalPrice = 0;
				savedVariables.finalPriceFormatted = '$0.00';
				savedVariables.handleStyle = null;
				savedVariables.handleUpgradeChosen = false;
				savedVariables.objectID = 0;
				savedVariables.softCloseUpgradeChosen = false;
				savedVariables.softCloseStandardChosen = false;
				savedVariables.componentAddedCount = 0;
				savedVariables.componentSelectedCount = 0;
				savedVariables.totalHandles = 0;
				savedVariables.handleUpgradeChosen = false;
				savedVariables.handleUpgradeTitle = $handleSelection.data('title');
				savedVariables.handleUpgradeVariantTitle = $handleSelection.data('varianttitle');
				savedVariables.handleStyle;
			}

			// Show loader
			$saveButton.addClass('is-saving');
			$saveButton.find('span').text('Saving');

			$.ajax({
				method: 'POST',
				url: planner_api_url + '/planner/update',
				data: JSON.stringify({
					plan_type: 'wardrobe',
					customer_id: customerID,
					plan_id: planID,
					plan: JSON.stringify(canvas.toJSON(['cabjaks', 'hasBorders', 'hasControls', 'selectable', 'hasRotatingPoint', 'lockRotation', 'lockScalingX', 'lockScalingY', 'lockScalingFlip', 'lockUniScaling'])),
					variables: JSON.stringify(savedVariables)
				}),
				timeout: 15000,
				cache: false,
				contentType: "application/json"
			}).done(function(resultJSON) {
				var result = resultJSON;
				if(result.response === 'Success') {
					$saveButton.find('span').text('Saved');
					clearTimeout(saveTimer);
					saveTimer = setTimeout(function() {
						$saveButton.find('span').text('Save');
					}, 15000);

					// Hide prompt if window closed without saving
					window.onbeforeunload = null;
				} else {
					$saveButton.find('span').text('Save');
					// Don't show error if doing sneaky save
					if(!addToCartAfterSave) {
						alert('Could not save plan. Please try again. (' + result.msg + '.)');
					}
				}
			}).fail(function() {
				$saveButton.find('span').text('Save');
				// Don't show error if doing sneaky save
				if(!addToCartAfterSave) {
					alert('Could not save plan. Please try again. (AJAX error.)');
				}
			}).always(function() {
				$saveButton.removeClass('is-saving');
				$saveButton.blur();
			});

			// Add to cart after saving
			/*
			if(addToCartAfterSave) {
				ajaxAddtoCart();
			}
			*/
		}
	}

	function onComponentSelected(options) {
		var productTitle,
		productDimensions = '',
		allObjects = [],
		objectGroup = [];

		// Show current product in sidebar
		$currentProductInfo.addClass('shown').siblings().removeClass('shown');

		// Update current product IDs
		currentProductTarget = options.target;
		currentProductID = options.target.cabjaks.productID;
		currentVariantID = options.target.cabjaks.variantID;
		currentVariant = null; // Don't bother updating the variant object, required info can be stored as variables
		currentProductProperties = options.target.cabjaks.properties;


		// Reset current component info data to current values of selected product
		componentWidth = currentProductTarget.canvas._activeObject.cabjaks.componentOptions[0];
		componentDepth = currentProductTarget.canvas._activeObject.cabjaks.componentOptions[1];
		componentHeight = currentProductTarget.canvas._activeObject.cabjaks.componentOptions[2];
		componentDrawers = currentProductTarget.canvas._activeObject.cabjaks.componentOptions[3];
		componentShelves = currentProductTarget.canvas._activeObject.cabjaks.componentOptions[4];
		componentType = currentProductTarget.canvas._activeObject.cabjaks.componentOptions[5];
		towerType = currentProductTarget.canvas._activeObject.cabjaks.componentOptions[6];


		// If the selected product is different
		if(currentProductID != currentProductSelected) {

			// Update selected product
			currentProductSelected = currentProductID;

			// Update current product
			currentProduct = window['product' + currentProductID];

			// Strip out extraneous words
			productTitle = currentProduct.title.replace('Wardrobe ', '');

			// Update title
			$currentProductInfo.find('.product-title').html(productTitle);
		}

		// Update image
		$currentProductImage.attr({
			src: options.target.cabjaks.image,
			srcset: options.target.cabjaks.image2x,
			alt: productTitle
		});

		$tips.find('p.edit').removeClass('disabled');

		//disable edit button if it can't be edited
		if(currentProduct.variants.length == 1 && currentProduct.options.length == 1 && currentProduct.options[0] == 'Title') {
			$tips.find('p.edit').addClass('disabled');
		}

		// Update price
		currentProductPrice = options.target.cabjaks.price;
		$currentProductInfo.find('.price').text(Shopify.formatMoney(currentProductPrice, moneyFormat));

		// Show product dimensions
		for(var i = 0; i < options.target.cabjaks.info.length; i++) {
			productDimensions += '<p><strong>' + options.target.cabjaks.info[i].title + ':</strong> ' + options.target.cabjaks.info[i].value + '</p>';

			// Update width/height for rulers
			if(options.target.cabjaks.info[i].title == 'Width') {
				rulerX2Val = removeMm(options.target.cabjaks.info[i].value);
			} else if(options.target.cabjaks.info[i].title == 'Height') {
				rulerY2Val = removeMm(options.target.cabjaks.info[i].value);
			}
		}

		$currentProductInfo.find('.current-product-options').html(productDimensions);

		// Figure out snapping
		canvas.forEachObject(function(obj) {

			// Skip if it's the object being moved
			if(obj === options.target) return;

			// Add all objects to array
			allObjects.push(obj);
		});

		// Create objects array for snapping
		for(var i = 0; i < allObjects.length; i++) {
			var addToGroup = true,
			objOuterGroup = allObjects[i].item(0),
			objSnapAreaID = allObjects[i].cabjaks.snapAreaID,
			objSnapArea = objOuterGroup.item(objSnapAreaID),
			objSnapAreaLeft = allObjects[i].getLeft(),
			objSnapAreaWidth = objSnapArea.getWidth() + 1, // Because of group
			objSnapAreaTop = allObjects[i].getTop(),
			objSnapAreaHeight = objSnapArea.getHeight() + 1; // Because of group

			// Loop through groups
			for(var j = 0; j < objectGroup.length; j++) {

				// Loop through items in group
				for(var k = 0; k < objectGroup[j].length; k++) {
					if(objectGroup[j][k].id == allObjects[i].cabjaks.id) {
						addToGroup = false;
					}
				}
			}

			if(addToGroup) {
				objectGroup.push([{
					id: allObjects[i].cabjaks.id,
					objSnapAreaLeft: objSnapAreaLeft,
					objSnapAreaWidth: objSnapAreaWidth,
					objSnapAreaTop: objSnapAreaTop,
					objSnapAreaHeight: objSnapAreaHeight
				}]);
			}
		}

		// Loop through objects
		canvas.forEachObject(function(obj) {

			// Skip if it's the object being moved
			if(obj === options.target) return;

			var objOuterGroup = obj.item(0),
			objSnapAreaID = obj.cabjaks.snapAreaID,
			objSnapArea = objOuterGroup.item(objSnapAreaID),
			objSnapAreaLeft = obj.getLeft(),
			objSnapAreaWidth = objSnapArea.getWidth() + 1, // Because of group
			objSnapAreaTop = obj.getTop(),
			objSnapAreaHeight = objSnapArea.getHeight() + 1, // Because of group
			intersections = [];

			// See which other components are together
			for(var i = 0; i < allObjects.length; i++) {

				// If there's an intersection
				if(allObjects[i].isContainedWithinObject(obj) || allObjects[i].intersectsWithObject(obj) || obj.isContainedWithinObject(allObjects[i])) {

					if(allObjects[i] === obj) continue;

					intersections.push({
						firstIntersection: allObjects[i].cabjaks.id,
						secondIntersection: obj.cabjaks.id
					});
				}
			}

			// Loop through objects which intersect
			for(var i = 0; i < intersections.length; i++) {
				var foundFirst = false,
				foundSecond = false,
				addPos = null,
				removePos = null;

				// Loop through groups
				for(var j = 0; j < objectGroup.length; j++) {

					// Loop through items in group
					for(var k = 0; k < objectGroup[j].length; k++) {

						if(objectGroup[j][k].id == intersections[i].firstIntersection) {
							removePos = j;
							foundFirst = true;
						}

						if(objectGroup[j][k].id == intersections[i].secondIntersection) {
							addPos = j;
							foundSecond = true;
						}

						if(foundFirst && foundSecond) {
							break;
						}
					}

					if(foundFirst && foundSecond) {
						break;
					}
				}

				if(foundFirst && foundSecond) {
					// If the first/second numbers are in different groups
					if(addPos != removePos) {
						// Swap numbers if the remove group already has multiple numbers
						if(objectGroup[removePos].length > 1) {

							// Move each number across (if one intersects, they'll all intersect)
							for(var l = 0; l < objectGroup[addPos].length; l++) {
								// Add to new group
								objectGroup[removePos].push({
									id: objectGroup[addPos][l].id,
									objSnapAreaLeft: objectGroup[addPos][l].objSnapAreaLeft,
									objSnapAreaWidth: objectGroup[addPos][l].objSnapAreaWidth,
									objSnapAreaTop: objectGroup[addPos][l].objSnapAreaTop,
									objSnapAreaHeight: objectGroup[addPos][l].objSnapAreaHeight
								});
							}

							// Remove from old group
							objectGroup.splice(addPos, 1);

						} else {
							// Add to new group
							objectGroup[addPos].push({
								id: objectGroup[removePos][0].id,
								objSnapAreaLeft: objectGroup[removePos][0].objSnapAreaLeft,
								objSnapAreaWidth: objectGroup[removePos][0].objSnapAreaWidth,
								objSnapAreaTop: objectGroup[removePos][0].objSnapAreaTop,
								objSnapAreaHeight: objectGroup[removePos][0].objSnapAreaHeight
							});

							// Remove from old group
							objectGroup.splice(removePos, 1);
						}
					}
				}
			}
		});

		// Loop through objects
		canvas.forEachObject(function(obj) {

			// Skip if it's the object being moved
			if(obj === options.target) return;

			for(var j = 0; j < objectGroup.length; j++) {

				var outerAreaLeft = null,
				outerAreaTop = null,
				outerAreaRight = null,
				outerAreaBottom = null,
				objFound = false;

				// Loop through items in group
				for(var k = 0; k < objectGroup[j].length; k++) {

					// Set outer snapping area
					if(outerAreaLeft === null || objectGroup[j][k].objSnapAreaLeft < outerAreaLeft) {
						outerAreaLeft = objectGroup[j][k].objSnapAreaLeft;
					}

					if(outerAreaTop === null || objectGroup[j][k].objSnapAreaTop < outerAreaTop) {
						outerAreaTop = objectGroup[j][k].objSnapAreaTop;
					}

					if(outerAreaRight === null || (objectGroup[j][k].objSnapAreaLeft + objectGroup[j][k].objSnapAreaWidth) > outerAreaRight) {
						outerAreaRight = objectGroup[j][k].objSnapAreaLeft + objectGroup[j][k].objSnapAreaWidth;
					}

					if(outerAreaBottom === null || (objectGroup[j][k].objSnapAreaTop + objectGroup[j][k].objSnapAreaHeight) > outerAreaBottom) {
						outerAreaBottom = objectGroup[j][k].objSnapAreaTop + objectGroup[j][k].objSnapAreaHeight;
					}

					// If matching ID found
					if(objectGroup[j][k].id == obj.cabjaks.id) {
						objFound = true;
					}
				}

				if(objFound) {
					obj.cabjaks.outerAreaLeft = outerAreaLeft;
					obj.cabjaks.outerAreaTop = outerAreaTop;
					obj.cabjaks.outerAreaRight = outerAreaRight;
					obj.cabjaks.outerAreaBottom = outerAreaBottom;
					break;
				}
			}
		});

		// Add offset for measurements from bottom of component
		rulerYOffset = 0;

		if(productTitle == 'Hanging Rail') {
			rulerYOffset = Math.round(options.target.getHeight() - rulerY2Val + 1); // Because of group
		}

		// Calculate new ruler values
		rulerX1ValNew = Math.round(options.target.getLeft());
		rulerY1ValNew = Math.round(options.target.getTop() + rulerYOffset);

		// Update rulers
		$rulerX2.html('<span>' + rulerX2Val + '</span>').css({
			'width': (rulerX2Val/roomWidth * 100).toFixed(2) + '%'
		});

		$rulerY2.html('<span>' + rulerY2Val + '</span>').css({
			'height': (rulerY2Val/roomHeight * 100).toFixed(2) + '%'
		});

		updateRulers(true);

		componentSelectedCount++;

		if(componentAddedCount > 2 && componentSelectedCount > 2) {
			progressInstructions = true;
		}
	}

	function findNewPos(distX, distY, target, xLeft, xRight, yAbove, yBelow, snapAxis, forceAxis) {

		var newLeft = null,
		newTop = null,
		focusX = false;

		if(snapAxis == 'x') {
			if(Math.abs(distX) > Math.abs(distY)) {
				focusX = true;
			}
		} else {
			if(Math.abs(distX) < Math.abs(distY)) {
				focusX = true;
			}
		}

		// Force snapping for rails
		if(forceAxis) {
			if(snapAxis == 'x') {
				focusX = false;
			} else {
				focusX = true;
			}
		}

		// See whether to focus on X or Y axis
		if(focusX) {
			if(distX > 0) {
				newLeft = xLeft;

				// Don't allow objects off canvas
				if(newLeft < (0 - 1)) {
					newLeft = 0;

					if(distY > 0) {
						newTop = yAbove;
					} else {
						newTop = yBelow;
					}

					// If too far up, swap to down
					if(newTop < 0) {
						newTop = yBelow;
					}

					// If too far down, swap to up
					if(newTop + target.getHeight() > roomHeight) {
						newTop = yAbove;
					}
				}

			} else {
				newLeft = xRight;

				// Don't allow objects off canvas
				if(newLeft + target.getWidth() > (roomWidth + 1)) {
					newLeft = roomWidth - target.getWidth();

					if(distY > 0) {
						newTop = yAbove;
					} else {
						newTop = yBelow;
					}

					// If too far up, swap to down
					if(newTop < 0) {
						newTop = yBelow;
					}

					// If too far down, swap to up
					if(newTop + target.getHeight() > roomHeight) {
						newTop = yAbove;
					}
				}
			}

		} else {
			if(distY > 0) {
				newTop = yAbove;

				// Don't allow objects off canvas
				if(newTop < (0 - 1)) {
					newTop = 0;

					if(distX > 0) {
						newLeft = xLeft;
					} else {
						newLeft = xRight;
					}

					// If too far left, swap to right
					if(newLeft < 0) {
						newLeft = xRight;
					}

					// If too far right, swap to left
					if(newLeft + target.getWidth() > roomWidth) {
						newLeft = xLeft;
					}
				}

			} else {
				newTop = yBelow;

				// Don't allow objects off canvas
				if(newTop + target.getHeight() > (roomHeight + 1)) {
					newTop = roomHeight - target.getHeight();

					if(distX > 0) {
						newLeft = xLeft;
					} else {
						newLeft = xRight;
					}

					// If too far left, swap to right
					if(newLeft < 0) {
						newLeft = xRight;
					}

					// If too far right, swap to left
					if(newLeft + target.getWidth() > roomWidth) {
						newLeft = xLeft;
					}
				}
			}
		}

		return {
			left: newLeft,
			top: newTop
		};
	}

	function onComponentDrag(options) {
		var targetOuterGroup = options.target.item(0),
		targetSnapAreaID = options.target.cabjaks.snapAreaID,
		targetSnapArea = targetOuterGroup.item(targetSnapAreaID),
		targetSnapAreaLeft = options.target.getLeft(),
		targetSnapAreaWidth = targetSnapArea.getWidth() + 1, // Because of group
		targetSnapAreaTop = options.target.getTop(),
		targetSnapAreaHeight = targetSnapArea.getHeight() + 1, // Because of group
		targetSnapAxis = options.target.cabjaks.snapAxis,
		targetForceAxis = options.target.cabjaks.forceAxis,
		targetSnapTop = options.target.cabjaks.snapTop;

		// Sets corner position coordinates based on current angle, width and height
		options.target.setCoords();

		// Calculate new ruler values
		rulerX1ValNew = Math.round(options.target.getLeft());
		rulerY1ValNew = Math.round(options.target.getTop());

		// Don't allow objects out of the room
		if(options.target.getLeft() < snap) {
			targetSnapAreaLeft = 0;
			options.target.setLeft(targetSnapAreaLeft);
			rulerX1ValNew = targetSnapAreaLeft;
		}

		if(options.target.getTop() < snap) {
			targetSnapAreaTop = 0;
			options.target.setTop(targetSnapAreaTop);
			rulerY1ValNew = targetSnapAreaTop;
		}

		if((options.target.getWidth() + 1 + options.target.getLeft()) > (roomWidth - snap)) {
			targetSnapAreaLeft = roomWidth - (options.target.getWidth() + 1); // Because of group
			options.target.setLeft(targetSnapAreaLeft);
			rulerX1ValNew = Math.round(targetSnapAreaLeft);
		}

		if((options.target.getHeight() + 1 + options.target.getTop()) > (roomHeight - snap)) {
			targetSnapAreaTop = roomHeight - (options.target.getHeight() + 1); // Because of group
			options.target.setTop(targetSnapAreaTop);
			rulerY1ValNew = Math.round(targetSnapAreaTop);
		}

		// Sets corner position coordinates based on current angle, width and height
		options.target.setCoords();

		// Loop through objects
		canvas.forEachObject(function(obj) {

			// Skip if it's the object being moved
			if(obj === options.target) return;

			var objOuterGroup = obj.item(0),
			objSnapAreaID = obj.cabjaks.snapAreaID,
			objSnapArea = objOuterGroup.item(objSnapAreaID),
			objSnapAreaLeft = obj.getLeft(),
			objSnapAreaWidth = objSnapArea.getWidth() + 1, // Because of group
			objSnapAreaTop = obj.getTop(),
			objSnapAreaHeight = objSnapArea.getHeight() + 1; // Because of group

			// If objects intersect
			if(options.target.isContainedWithinObject(obj) || options.target.intersectsWithObject(obj) || obj.isContainedWithinObject(options.target)) {

				var distX = ((objSnapAreaLeft + objSnapAreaWidth) / 2) - ((targetSnapAreaLeft + targetSnapAreaWidth) / 2),
				distY = ((objSnapAreaTop + objSnapAreaHeight) / 2) - ((targetSnapAreaTop + targetSnapAreaHeight) / 2),
				xLeft = objSnapAreaLeft - targetSnapAreaWidth,
				xRight = objSnapAreaLeft + objSnapAreaWidth,
				yAbove = objSnapAreaTop - targetSnapAreaHeight,
				yBelow = objSnapAreaTop + objSnapAreaHeight,
				newPos = findNewPos(distX, distY, options.target, xLeft, xRight, yAbove, yBelow, targetSnapAxis, targetForceAxis),
				newLeft = newPos.left,
				newTop = newPos.top;

				if(newLeft !== null && !options.target.cabjaks.image.includes('hanging-rail')) {
					options.target.setLeft(newLeft);
					rulerX1ValNew = Math.round(newLeft);
					targetSnapAreaLeft = newLeft;
				}

				if(newTop !== null && !options.target.cabjaks.image.includes('hanging-rail')) {
					options.target.setTop(newTop);
					rulerY1ValNew = Math.round(newTop);
					targetSnapAreaTop = newTop;
				}
			}
		});

		// Sets corner position coordinates based on current angle, width and height
		options.target.setCoords();

		// If objects still overlap

		// Loop through objects
		canvas.forEachObject(function(obj) {

			// Skip if it's the object being moved
			if(obj === options.target) return;

			var objOuterGroup = obj.item(0),
			objSnapAreaID = obj.cabjaks.snapAreaID,
			objSnapArea = objOuterGroup.item(objSnapAreaID),
			objSnapAreaLeft = obj.getLeft(),
			objSnapAreaWidth = objSnapArea.getWidth() + 1, // Because of group
			objSnapAreaTop = obj.getTop(),
			objSnapAreaHeight = objSnapArea.getHeight() + 1, // Because of group
			outerAreaLeft = obj.cabjaks.outerAreaLeft,
			outerAreaTop = obj.cabjaks.outerAreaTop,
			outerAreaRight = obj.cabjaks.outerAreaRight,
			outerAreaBottom = obj.cabjaks.outerAreaBottom,
			snap = defaultSnap,
			intersectSize = null;

			// If objects intersect
			if(options.target.isContainedWithinObject(obj) || options.target.intersectsWithObject(obj) || obj.isContainedWithinObject(options.target)) {

				var intersectLeft = null,
				intersectTop = null,
				intersectWidth = null,
				intersectHeight = null,
				targetLeft = targetSnapAreaLeft,
				targetRight = targetSnapAreaLeft + targetSnapAreaWidth,
				targetTop = targetSnapAreaTop,
				targetBottom = targetSnapAreaTop + targetSnapAreaHeight,
				objectLeft = objSnapAreaLeft,
				objectRight = objSnapAreaLeft + objSnapAreaWidth,
				objectTop = objSnapAreaTop,
				objectBottom = objSnapAreaTop + objSnapAreaHeight;

				// Find intersect information for X axis
				if(targetLeft >= objectLeft && targetLeft <= objectRight) {
					intersectLeft = targetLeft;
					intersectWidth = objSnapAreaWidth - (intersectLeft - objectLeft);

				} else if(objectLeft >= targetLeft && objectLeft <= targetRight) {
					intersectLeft = objectLeft;
					intersectWidth = targetSnapAreaWidth - (intersectLeft - targetLeft);
				}

				// Find intersect information for Y axis
				if(targetTop >= objectTop && targetTop <= objectBottom) {
					intersectTop = targetTop;
					intersectHeight = objSnapAreaHeight - (intersectTop - objectTop);

				} else if(objectTop >= targetTop && objectTop <= targetBottom) {
					intersectTop = objectTop;
					intersectHeight = targetSnapAreaHeight - (intersectTop - targetTop);
				}

				// Find intersect size (this will be 0 if objects are touching but not overlapping)
				if(intersectWidth > 0 && intersectHeight > 0) {
					intersectSize = intersectWidth * intersectHeight;
				}
			}

			// If objects are intersecting, reposition outside all shapes which touch
			if(intersectSize !== null) {

				var distX = (outerAreaRight / 2) - ((targetSnapAreaLeft + targetSnapAreaWidth) / 2),
				distY = (outerAreaBottom / 2) - ((targetSnapAreaTop + targetSnapAreaHeight) / 2),
				xLeft = outerAreaLeft - targetSnapAreaWidth,
				xRight = outerAreaRight,
				yAbove = outerAreaTop - targetSnapAreaHeight,
				yBelow = outerAreaBottom,
				newPos = findNewPos(distX, distY, options.target, xLeft, xRight, yAbove, yBelow, targetSnapAxis, targetForceAxis),
				newLeft = newPos.left,
				newTop = newPos.top;

				if(newLeft !== null && !options.target.cabjaks.image.includes('hanging-rail')) {
					options.target.setLeft(newLeft);
					rulerX1ValNew = Math.round(newLeft);
					targetSnapAreaLeft = newLeft;
				}

				if(newTop !== null && !options.target.cabjaks.image.includes('hanging-rail')) {
					options.target.setTop(newTop);
					rulerY1ValNew = Math.round(newTop);
					targetSnapAreaTop = newTop;
				}

				// Sets corner position coordinates based on current angle, width and height
				options.target.setCoords();
			}

			var newLeft = null,
			newTop = null;

			// Snap objects to each other horizontally

			// If bottom points are on same Y axis
			if(Math.abs((targetSnapAreaTop + targetSnapAreaHeight) - outerAreaBottom) < snap) {
				// Snap target BL to object BR
				if(Math.abs(targetSnapAreaLeft - outerAreaRight) < snap) {
					newLeft = outerAreaRight;
					newTop = outerAreaBottom - targetSnapAreaHeight;
				}

				// Snap target BR to object BL
				if(Math.abs((targetSnapAreaLeft + targetSnapAreaWidth) - outerAreaLeft) < snap) {
					newLeft = outerAreaLeft - targetSnapAreaWidth;
					newTop = outerAreaBottom - targetSnapAreaHeight;
				}
			}

			// If top points are on same Y axis
			if(targetSnapTop) {
				if(Math.abs(targetSnapAreaTop - outerAreaTop) < snap) {
					// Snap target TL to object TR
					if(Math.abs(targetSnapAreaLeft - outerAreaRight) < snap) {
						newLeft = outerAreaRight;
						newTop = outerAreaTop;
					}

					// Snap target TR to object TL
					if(Math.abs((targetSnapAreaLeft + targetSnapAreaWidth) - outerAreaLeft) < snap) {
						newLeft = outerAreaLeft - targetSnapAreaWidth;
						newTop = outerAreaTop;
					}
				}
			}

			// Snap objects to each other vertically

			// If right points are on same X axis
			if(Math.abs((targetSnapAreaLeft + targetSnapAreaWidth) - outerAreaRight) < snap) {
				if(targetSnapTop) {
					// Snap target TR to object BR
					if(Math.abs(targetSnapAreaTop - outerAreaBottom) < snap) {
						newLeft = outerAreaRight - targetSnapAreaWidth;
						newTop = outerAreaBottom;
					}
				}

				// Snap target BR to object TR
				if(Math.abs((targetSnapAreaTop + targetSnapAreaHeight) - outerAreaTop) < snap) {
					newLeft = outerAreaRight - targetSnapAreaWidth;
					newTop = outerAreaTop - targetSnapAreaHeight;
				}
			}

			// If left points are on same X axis
			if(Math.abs(targetSnapAreaLeft - outerAreaLeft) < snap) {
				if(targetSnapTop) {
					// Snap target TL to object BL
					if(Math.abs(targetSnapAreaTop - outerAreaBottom) < snap) {
						newLeft = outerAreaLeft;
						newTop = outerAreaBottom;
					}
				}

				// Snap target BL to object TL
				if(Math.abs((targetSnapAreaTop + targetSnapAreaHeight) - outerAreaTop) < snap) {
					newLeft = outerAreaLeft;
					newTop = outerAreaTop - targetSnapAreaHeight;
				}
			}

			if(newLeft !== null) {
				options.target.setLeft(newLeft);
				rulerX1ValNew = Math.round(newLeft);
			}

			if(newTop !== null) {
				options.target.setTop(newTop);
				rulerY1ValNew = Math.round(newTop);
			}
		});

		// Include offset
		rulerY1ValNew = rulerY1ValNew + rulerYOffset;

		// Update rulers
		updateRulers();

		// Show prompt if window closed without saving
		window.onbeforeunload = confirmOnPageExit;
	}

	function onDeselect() {
		// Unselect products
		canvas.deactivateAll().renderAll();

		// Show tip, hide current product
		if(!dragInstructions) {
			if(!progressInstructions) {
				// Show default tip
				$tips.find('.tip-3').addClass('shown').siblings().removeClass('shown');
			} else {
				// Show progress tip
				$tips.find('.tip-4').addClass('shown').siblings().removeClass('shown');
			}
		}

		// Hide rulers
		$ruler.removeClass('shown');

		// hide current product info popup
		$currentProductInfo.removeClass('shown');

		// Remove components which are off the page
		cleanUp();
	}

	function showProductOptions() {
		// Reset old options
		drawersMax = 1;
		shelvesMax = 2;

		// Reset view/buttons
		$componentOptions.addClass('shown');
		$towerOptions.removeClass('shown');
		$componentAddBtn.addClass('shown');
		$componentConfigureBtn.removeClass('shown');
		$towerDrawersWrapper.removeClass('shown');

		// Remove old options
		$productOptions.find('.selector-wrapper').remove();

		// Update select with current product variant IDs
		var selectOptions = '';
		for(var i = 0; i < currentProduct.variants.length; i++) {
			selectOptions += '<option value="' + currentProduct.variants[i].id + '"></option>';
		}
		$productSelect.empty().prepend(selectOptions);

		// Create dropdown from JSON
		new Shopify.OptionSelectors('productSelect', {
			product: currentProduct,
			enableHistoryState: false
		});

		// Clear existing saved options
		Shopify.optionsMap = {};

		// Link selectors
		Shopify.linkOptionSelectors(currentProduct);

		// Add label if only one product option and it isn't 'Title'. Could be 'Size'.
		if(currentProduct.options.length == 1 && currentProduct.options[0] != 'Title') {
			$productOptions.find('.selector-wrapper:eq(0)').prepend('<label>' + currentProduct.options[0] + '</label>');
		}

		// Select defaults for towers, side and top panels
		if(componentType == 'Towers' || currentProduct.title.indexOf('Side Panel') > -1 || currentProduct.title.indexOf('Top Panel') > -1) {

			// Loop through selects
			$componentOptions.find('.selector-wrapper').each(function() {
				var $selectorWrapper = $(this);

				// Select default width
				if($selectorWrapper.find('label').text() == 'Width') {
					$selectorWrapper.find('select option[value=' + defaultTowerWidth + 'mm]').prop('selected', true);

				// Select default depth
				} else if($selectorWrapper.find('label').text() == 'Depth') {
					$selectorWrapper.find('select option[value=' + defaultTowerDepth + 'mm]').prop('selected', true);

				// Select default height
				} else if($selectorWrapper.find('label').text() == 'Height') {
					$selectorWrapper.find('select option[value=' + defaultTowerHeight + 'mm]').prop('selected', true);
				}
			});
		}

		// Extra options for towers
		if(componentType == 'Towers') {
			$componentAddBtn.removeClass('shown');
			$componentConfigureBtn.addClass('shown');

			if(towerType == 'Drawers' || towerType == 'Drawers and Handles') {
				$towerDrawersWrapper.addClass('shown');
			}
		}

		// Render update or create button
		if(isUpdating) {
			$productOptions.find('.action-buttons .btn').html('Save');

			//Heading
			$productOptions.find('.product-options-heading').html('Edit');
			//Show image of product being updated
			$productOptions.find('.product-image').html($currentProductImage.clone()).show();
			//Show title of product being updated
			$productOptions.find('.product-title').html($currentProductInfo.find('.product-title').clone()).show();
		} else {
			$productOptions.find('.action-buttons .btn').html('Add to Design');

			$productOptions.find('.product-options-heading').html('');
			$productOptions.find('.product-image').hide();
			$productOptions.find('.product-title').hide();
		}

		// Show 'select options' tip
		$tips.find('.tip-2').addClass('shown').siblings().removeClass('shown');
		$dragInstructions.removeClass('shown');
		$overlay.addClass('shown');
		$fullOverlay.addClass('shown mobile-only');
		$productOptions.addClass('shown');
	}

	function setupTowerOptions(initialSetup) {
		var initialSetup = (typeof initialSetup === 'undefined') ? true : initialSetup,
		defaultDrawers = null,
		defaultShelves = null,
		selectedShelves = null;

		if(drawersMax > 4) {
			defaultDrawers = Math.ceil(drawersMax / 2);
		} else {
			defaultDrawers = drawersMax;
		}

		if(shelvesMax > 4) {
			defaultShelves = Math.ceil(shelvesMax / 2);
		} else {
			defaultShelves = shelvesMax;
		}

		// Tower drawers (only run on initial setup)
		if(initialSetup) {
			var selectOptions = '';
			for(var i = drawersMin; i <= drawersMax; i++) {
				selectOptions += '<option value="' + i + '">' + i + '</option>';
			}
			$towerDrawersSelect.empty().prepend(selectOptions);

			// Select default
			$towerDrawersSelect.find('option[value=' + defaultDrawers + ']').prop('selected', true);

		// Save old shelves value if refreshing selects
		} else {
			selectedShelves = parseInt($towerShelvesSelect.val(), 10);

			// Save old selected as default if it's available in the new select
			if(selectedShelves <= shelvesMax) {
				defaultShelves = selectedShelves;
			}
		}

		// Tower shelves
		var selectOptions = '';
		for(var i = shelvesMin; i <= shelvesMax; i++) {
			selectOptions += '<option value="' + i + '">' + i + '</option>';
		}
		$towerShelvesSelect.empty().prepend(selectOptions);
		// Select default
		$towerShelvesSelect.find('option[value=' + defaultShelves + ']').prop('selected', true);
	}

	function hideProductOptions() {
		if(!dragInstructions) {
			$dragInstructions.removeClass('shown');

			if(!progressInstructions) {
				// Show default tip
				$tips.find('.tip-3').addClass('shown').siblings().removeClass('shown');
			} else {
				// Show progress tip
				$tips.find('.tip-4').addClass('shown').siblings().removeClass('shown');
			}
		} else {
			$dragInstructions.addClass('shown');
			// Show 'getting started' tip
			$tips.find('.tip-1').addClass('shown').siblings().removeClass('shown');
		}
		$overlay.removeClass('shown');
		$fullOverlay.removeClass('shown mobile-only');
		$productOptions.removeClass('shown');
		$componentOptions.addClass('shown');
		$towerOptions.removeClass('shown');
		$componentAddBtn.addClass('shown');
		$componentConfigureBtn.removeClass('shown');
		$towerDrawersWrapper.removeClass('shown');
	}

	function hideLoadOptions() {
		// Unselect
		$savedPlan.find('.choice').removeClass('selected');

		// Close popup
		$fullOverlay.removeClass('shown');
		$loadOptions.removeClass('shown');
	}

	function hideSaveOptions() {
		// Close popup
		$fullOverlay.removeClass('shown');
		$saveOptions.removeClass('shown');
	}

	function hideLogin() {
		// Unselect
		$savedPlan.find('.choice').removeClass('selected');

		// Close popup
		$fullOverlay.removeClass('shown');
		$customerForm.removeClass('shown');
	}

	function hideRegister() {
		// Go back to login screen
		$register.removeClass('shown');
		$login.addClass('shown');

		// Close popup
		$fullOverlay.removeClass('shown');
		$customerForm.removeClass('shown');
	}

	function hideWarning() {
		// Close popup
		$fullOverlay.removeClass('shown');
		$warning.removeClass('shown');

		goToNextStepAndValidate(4);
	}

	// Create a component
	function createComponent(width, depth, height, drawers, shelves, componentType, towerType, leftPos, topPos) {
		var leftPos = (typeof leftPos === 'undefined') ? (roomWidth / 2) - (width / 2) : leftPos,
		topPos = (typeof topPos === 'undefined') ? (roomHeight / 2) - (height / 2) : topPos,
		componentInfo = [],
		componentOptions = [width, depth, height, drawers, shelves, componentType, towerType],
		componentParts = [],
		componentOuterParts = [],
		baseFill = white,
		origWidth = width,
		origHeight = height,
		snapAreaID = null,
		snapAreaWidth = null,
		snapAreaHeight = null,
		snapAxis = 'y',
		forceAxis = false,
		snapTop = true,
		allowDrawerUpgrade = false,
		componentQuantity = 1,
		towerComponentProducts = [],
		towerComponentInfo = [],
		towerComponentsCount = 6,
		towerComponentID = null,
		towerComponentVariant = null,
		towerComponentPrice = null,
		towerComponentImageUrl = null,
		towerComponentImageUrl2x = null,
		matchWidth = true,
		matchDepth = true,
		matchHeight = true,
		foundWidth = false,
		foundDepth = false,
		foundHeight = false,
		oldSuggestedRailSupports = suggestedRailSupports,
		oldSuggestedShelfSupports = suggestedShelfSupports,
		oldTotalDrawers,
		drawerSpacing;

		// Align to bottom for towers and panels
		if(componentType == 'Towers' || currentProduct.title.indexOf('Side Panel') > -1) {
			topPos = roomHeight - height;
		}

		// Decrease width and height by 2px to fix Fabric JS group bug where 1px is added
		width = width - 2;
		height = height - 2;

		snapAreaHeight = height + 1; // Because of group

		if(componentType == 'Towers') {
			var backSupport = new fabric.Rect({
				width: width,
				height: backSupportHeight,
				left: 0,
				top: 0,
				fill: lightGrey
			});

			componentParts.push(backSupport);

			var left = new fabric.Rect({
				width: sideWidth,
				height: height,
				left: 0,
				top: 0,
				fill: baseFill
			});

			componentParts.push(left);

			var right = new fabric.Rect({
				width: sideWidth,
				height: height,
				left: width - sideWidth,
				top: 0,
				fill: baseFill
			});

			componentParts.push(right);

			// Create drawers
			if(drawers > 0) {
				// Drawers without handles
				if(towerType == 'Drawers') {
					drawerSpacing = drawerHeight + spaceBetweenDrawers;

					for(var i = 0; i < drawers; i++) {
						var drawer = new fabric.Rect({
							width: width,
							height: drawerHeight,
							left: 0,
							top: height - drawerDistanceFromFloor - drawerHeight - (i * drawerSpacing),
							fill: baseFill
						});

						componentParts.push(drawer);
					}

				// Drawers with handles
				} else if(towerType == 'Drawers and Handles') {
					drawerSpacing = drawerHeight;

					// Save handle count
					componentHandleCount = drawers;

					for(var i = 0; i < drawers; i++) {
						var drawer = new fabric.Rect({
							width: width,
							height: drawerHeight,
							left: 0,
							top: height - drawerDistanceFromFloor - drawerHeight - (i * drawerSpacing),
							fill: baseFill
						});

						componentParts.push(drawer);

						var drawerTop = new fabric.Rect({
							width: width,
							height: 4,
							left: 0,
							top: height - drawerDistanceFromFloor - drawerHeight - (i * drawerSpacing),
							fill: midGrey
						});

						componentParts.push(drawerTop);

						var drawerHandle = new fabric.Rect({
							width: 170,
							height: 8,
							left: (width - 170) / 2,
							top: height - drawerDistanceFromFloor - drawerHeight + 60 - (i * drawerSpacing),
							fill: darkGrey
						});

						componentParts.push(drawerHandle);
					}
				}
			}

			// Create shelves
			if(shelves > 0) {
				// If there's also drawers
				if(drawers > 0) {
					var shelvesStart,
					shelfSpacing;

					shelvesStart = height - drawerDistanceFromFloor - (drawers * drawerSpacing);
					shelfSpacing = shelvesStart / shelves;

					for(var i = 0; i < shelves; i++) {
						var shelf = new fabric.Rect({
							width: width - (sideWidth * 2),
							height: sideWidth,
							left: sideWidth,
							top: shelvesStart - sideWidth - (i * shelfSpacing),
							fill: baseFill
						});

						componentParts.push(shelf);
					}

				// If there's only shelves
				} else {
					var shelfSpacing = (height - shelfDistanceFromFloor) / shelves;
					for(var i = 0; i < shelves; i++) {
						var shelf = new fabric.Rect({
							width: width - (sideWidth * 2),
							height: sideWidth,
							left: sideWidth,
							top: shelfSpacing + (i * shelfSpacing),
							fill: baseFill
						});

						componentParts.push(shelf);
					}
				}
			}

		// Normal components
		} else {
			if(currentProduct.title == 'Wardrobe Hanging Rail') {
				var topVoid = 50;

				// Figure out rail supports needed (1 pair per rail)
				suggestedRailSupports = suggestedRailSupports + 1;

				// Increase snap area
				snapAreaHeight = snapAreaHeight + topVoid;

				// Make base grey for hanging rails
				baseFill = midGrey;

				var baseTopVoid = new fabric.Rect({
					width: width,
					height: topVoid,
					left: 0,
					top: 0,
					fill: 'transparent'
				});

				componentParts.push(baseTopVoid);

				var base = new fabric.Rect({
					width: width,
					height: height,
					left: 0,
					top: topVoid,
					fill: baseFill
				});

			} else {
				var base = new fabric.Rect({
					width: width,
					height: height,
					left: 0,
					top: 0,
					fill: baseFill
				});
			}

			componentParts.push(base);
		}

		var snapArea = new fabric.Rect({
			width: 10, // Gets set properly later
			height: 10, // Gets set properly later
			left: 0,
			top: 0,
			fill: 'transparent'
		});

		snapAreaID = componentParts.push(snapArea) - 1;

		var component = new fabric.Group(componentParts, {
			left: 0,
			top: 0,
			angle: 0
		});

		componentOuterParts.push(component);

		// Update snap area size (setting it earlier gives weird positions)
		if(!snapAreaWidth) {
			snapAreaWidth = component.getWidth();
		}
		snapArea.setWidth(snapAreaWidth);

		if(!snapAreaHeight) {
			snapAreaHeight = component.getHeight();
		}
		snapArea.setHeight(snapAreaHeight);

		var componentOuter = new fabric.Group(componentOuterParts, {
			left: leftPos,
			top: topPos,
			hasBorders: false,
			hasControls: false,
			hasRotatingPoint: false,
			lockRotation: true,
			lockScalingX: true,
			lockScalingY: true,
			lockScalingFlip: true,
			lockUniScaling: true
		});

		// Snap differently if top panel
		if(currentProduct.title == 'Wardrobe Top Panel') {
			snapAxis = 'x';
			snapTop = false;
			topPanelAdded = true;
		} else if(currentProduct.title == 'Wardrobe Hanging Rail') {
			forceAxis = true;
		}

		// Save out the existing 'no product' image on first run
		if(!noProductImageUrl) {
			noProductImageUrl = $currentProductImage.attr('src');
			noProductImageUrl2x = $currentProductImage.attr('srcset');
		}

		// Get image info, resize image
		if(currentProduct.featured_image) {
			currentProductImageUrl = Shopify.Image.getSizedImageUrl(currentProduct.featured_image, 'medium');
			currentProductImageUrl2x = Shopify.Image.getSizedImageUrl(currentProduct.featured_image, 'large') + ' 2x';

			// Find specific variant image if it's set
			if(currentProduct.images.length > 1) {
				// If there's multiple variants
				if(currentProduct.variants.length > 1) {
					// Loop through variants
					for(var i = 0; i < currentProduct.variants.length; i++) {
						// Find current variant
						if(currentProduct.variants[i].id == currentVariantID) {
							// If a variant image is set
							if(currentProduct.variants[i].featured_image) {
								currentProductImageUrl = Shopify.Image.getSizedImageUrl(currentProduct.variants[i].featured_image.src, 'medium');
								currentProductImageUrl2x = Shopify.Image.getSizedImageUrl(currentProduct.variants[i].featured_image.src, 'large') + ' 2x';
							}
							break;
						}
					}
				}
			}
		} else {
			currentProductImageUrl = noProductImageUrl;
			currentProductImageUrl2x = noProductImageUrl2x;
		}

		// Save out info for product info box, products summary
		if(origWidth) {
			componentInfo.push({
				title: 'Width',
				value: origWidth + 'mm'
			});
		}

		if(depth) {
			componentInfo.push({
				title: 'Depth',
				value: depth + 'mm'
			});
		}

		if(origHeight) {
			componentInfo.push({
				title: 'Height',
				value: origHeight + 'mm'
			});
		}

		// Update properties
		currentProductProperties = {};

		// Add tower parts to summary list
		if(componentType == 'Towers') {

			currentProductPrice = 0;

			var missingTowerParts = [];

			// Loop through each tower component, adding to cart
			for(var m = 0; m < towerComponentsCount; m++) {

				// Reset variant
				componentQuantity = 1;
				towerComponentID = null;
				towerComponentVariant = null;
				towerComponentPrice = 0;
				towerComponentImageUrl = null;
				towerComponentImageUrl2x = null;
				matchWidth = true;
				matchDepth = true;
				matchHeight = true;
				currentProductProperties = {};
				allowDrawerUpgrade = false;

				// Figure out what we're adding
				if(m == 0) {
					// Add side panels
					currentProduct = sidePanelProduct;
					matchWidth = false;
					componentQuantity = 2;

				} else if(m == 1) {
					// Add back support panel
					currentProduct = backSupportProduct;
					matchDepth = false;
					matchHeight = false;

				} else if(m == 2) {
					// Add fixed shelves
					currentProduct = fixedShelfProduct;
					matchHeight = false;
					componentQuantity = 2;

				} else if(m == 3) {
					// Add shelves
					currentProduct = shelfProduct;
					matchHeight = false;

					// Account for the hidden fixed shelf at the bottom of the drawer towers
					if(towerType == 'Drawers' || towerType == 'Drawers and Handles') {
						// Skip shelves if there's only 1 (only use fixed shelves)
						if(shelves <= 1) {
							continue;
						}

						componentQuantity = shelves - 1;

					// Otherwise if shelf tower
					} else {
						// Skip shelves if there's only 2 (only use fixed shelves)
						if(shelves <= 2) {
							continue;
						}

						componentQuantity = shelves - 2;
					}

					// Figure out shelf supports needed
					suggestedShelfSupports = suggestedShelfSupports + (componentQuantity * 4);

				} else if(m == 4) {
					if(towerType == 'Drawers') {
						// Add drawers
						if(softCloseUpgradeChosen) {
							currentProduct = softCloseProduct;
						} else {
							currentProduct = drawerProduct;
						}
						matchHeight = false;
						componentQuantity = drawers;
						allowDrawerUpgrade = true;
					} else {
						// Skip drawers
						continue;
					}

				} else if(m == 5) {
					if(towerType == 'Drawers and Handles') {
						// Add drawers with handles
						if(softCloseUpgradeChosen) {
							currentProduct = softCloseHandleProduct;
						} else {
							currentProduct = drawerHandleProduct;
						}
						matchHeight = false;
						componentQuantity = drawers;
						allowDrawerUpgrade = true;

						// Add hidden handle count
						currentProductProperties = {
							'_Handles': 1
						};
					} else {
						// Skip drawers with handles
						continue;
					}
				}

				// Find correct variant
				if(currentProduct && currentProduct.variants.length > 1) {
					for(var i = 0; i < currentProduct.variants.length; i++) {
						foundWidth = false;
						foundDepth = false;
						foundHeight = false;

						if(!matchWidth) {
							foundWidth = true;
						}

						if(!matchDepth) {
							foundDepth = true;
						}

						if(!matchHeight) {
							foundHeight = true;
						}

						// Loop through variants
						for(var j = 0; j < currentProduct.options.length; j++) {
							if(currentProduct.options[j] == 'Width') {
								if(matchWidth) {
									if(origWidth == removeMm(currentProduct.variants[i]['option' + (j + 1)])) {
										foundWidth = true;
									}
								}

							} else if(currentProduct.options[j] == 'Depth') {
								if(matchDepth) {
									if(depth == removeMm(currentProduct.variants[i]['option' + (j + 1)])) {
										foundDepth = true;
									}
								}

							} else if(currentProduct.options[j] == 'Height') {
								if(matchHeight) {
									if(origHeight == removeMm(currentProduct.variants[i]['option' + (j + 1)])) {
										foundHeight = true;
									}
								}
							}

							if(foundWidth && foundDepth && foundHeight) {
								break;
							}
						}

						if(foundWidth && foundDepth && foundHeight) {
							towerComponentVariant = currentProduct.variants[i];
							break;
						}
					}
				}

				// If variant found
				if(towerComponentVariant) {
					// Duplicate info (because we're changing dimensions for each component)
					towerComponentInfo = componentInfo.slice(0);
					towerComponentID = towerComponentVariant.id;
					towerComponentPrice = towerComponentVariant.price;

					// Save IDs and quantities for if the tower is deleted
					towerComponentProducts.push({
						id: towerComponentID,
						quantity: componentQuantity,
						properties: currentProductProperties
					});

					// Figure out tower price based on components
					currentProductPrice += (towerComponentPrice * componentQuantity);

					// Override dimensions shown (separate loops so splice works properly)
					if(!matchWidth || !matchHeight) {
						// Override width info - set to panel width, not tower width
						if(!matchWidth) {
							for(var i = 0; i < towerComponentInfo.length; i++) {
								if(towerComponentInfo[i].title == 'Width') {
									towerComponentInfo[i] = {
										title: 'Width',
										value: sideWidth + 'mm'
									};
									break;
								}
							}
						}

						// Remove depth info
						if(!matchDepth) {
							for(var i = 0; i < towerComponentInfo.length; i++) {
								if(towerComponentInfo[i].title == 'Depth') {
									towerComponentInfo.splice(i, 1);
									break;
								}
							}
						}

						// Remove height info
						if(!matchHeight) {
							for(var i = 0; i < towerComponentInfo.length; i++) {
								if(towerComponentInfo[i].title == 'Height') {
									towerComponentInfo.splice(i, 1);
									break;
								}
							}
						}
					}

					if(currentProduct.featured_image) {
						towerComponentImageUrl = Shopify.Image.getSizedImageUrl(currentProduct.featured_image, 'medium');
						towerComponentImageUrl2x = Shopify.Image.getSizedImageUrl(currentProduct.featured_image, 'large') + ' 2x';
					} else {
						towerComponentImageUrl = noProductImageUrl;
						towerComponentImageUrl2x = noProductImageUrl2x;
					}

					// Loop through existing summary products, update quantity, remove existing product
					for(var i = 0; i < addtoCartQueue.length; i++) {
						// If the variant has already been added
						if(addtoCartQueue[i].id == towerComponentID) {
							// If properties also match
							if(JSON.stringify(addtoCartQueue[i].properties) === JSON.stringify(currentProductProperties)) {
								// Increment quantity
								componentQuantity = componentQuantity + addtoCartQueue[i].quantity;
								// Remove old item
								addtoCartQueue.splice(i, 1);
								break;
							}
						}
					}

					addtoCartQueue.push({
						id: towerComponentID,
						title: currentProduct.title.replace('Wardrobe ', ''),
						quantity: componentQuantity,
						price: towerComponentPrice,
						price_formatted: Shopify.formatMoney(towerComponentPrice, moneyFormat),
						line_price: towerComponentPrice * componentQuantity,
						line_price_formatted: Shopify.formatMoney(towerComponentPrice * componentQuantity, moneyFormat),
						img: towerComponentImageUrl,
						img2x: towerComponentImageUrl2x,
						info: towerComponentInfo,
						properties: currentProductProperties,
						soft_close_drawers: allowDrawerUpgrade
					});

				} else {
					// No matching variant — never skip a tower part silently (CAB-493),
					// as the plan would save/order without it
					missingTowerParts.push(currentProduct ? currentProduct.title : 'Tower part');
					console.error('Tower part could not be matched to a variant:', currentProduct ? currentProduct.title : '(product missing)', 'for tower', origWidth + 'x' + depth + 'x' + origHeight);
				}
			}

			if(missingTowerParts.length) {
				alert('Some required tower parts could not be added to your plan: ' + missingTowerParts.join(', ') + '. Please contact CabJaks before ordering.');
			}

			// Update total handles
			totalHandles = totalHandles + componentHandleCount;

			// Show handle choice
			if(totalHandles > 0) {
				$handleSelection.addClass('shown');

				// Update handle upgrade price
				$handleUpgradePrice.each(function() {
					$(this).html(Shopify.formatMoney(($(this).data('price')) * totalHandles));
				})

				// Update handle upgrade quantity if needed
				if(handleUpgradeChosen) {
					for(var i = 0; i < addtoCartQueue.length; i++) {
						// Find in summary list
						if(addtoCartQueue[i].title == handleUpgradeTitle) {
							// Update to new quantity
							addtoCartQueue[i].quantity = totalHandles;
							addtoCartQueue[i].line_price = handleUpgradePrice * totalHandles;
							addtoCartQueue[i].line_price_formatted = Shopify.formatMoney(handleUpgradePrice * totalHandles, moneyFormat);
							break;
						}
					}
				}
			}

			// Store old total drawer counts
			oldTotalDrawers = totalDrawers;

			// Update total drawer counts
			totalDrawers = totalDrawers + drawers;

			// Show soft close upgrade
			if(totalDrawers > 0) {
				$softCloseSelection.addClass('shown');

				// Update soft close price
				$softClosePrice.html(Shopify.formatMoney(softCloseUpgradePrice * totalDrawers));
			}

		// Add component to summary list
		} else {
			// Loop through existing summary products, update quantity, remove existing product
			for(var i = 0; i < addtoCartQueue.length; i++) {
				// If the variant has already been added
				if(addtoCartQueue[i].id == currentVariantID) {
					// If properties also match
					if(JSON.stringify(addtoCartQueue[i].properties) === JSON.stringify(currentProductProperties)) {
						// Increment quantity
						componentQuantity = addtoCartQueue[i].quantity + 1;
						// Remove old item
						addtoCartQueue.splice(i, 1);
						break;
					}
				}
			}

			addtoCartQueue.push({
				id: currentVariantID,
				title: currentProduct.title.replace('Wardrobe ', ''),
				quantity: componentQuantity,
				price: currentProductPrice,
				price_formatted: Shopify.formatMoney(currentProductPrice, moneyFormat),
				line_price: currentProductPrice * componentQuantity,
				line_price_formatted: Shopify.formatMoney(currentProductPrice * componentQuantity, moneyFormat),
				img: currentProductImageUrl,
				img2x: currentProductImageUrl2x,
				info: componentInfo,
				properties: currentProductProperties,
				soft_close_drawers: allowDrawerUpgrade
			});
		}

		// Update automatic support quantities
		if (
			oldSuggestedRailSupports !== suggestedRailSupports ||
			oldSuggestedShelfSupports !== suggestedShelfSupports
		) {
			updateSuggestedSupportCards();
		}

		// Save component options
		componentOuter.cabjaks = {};
		componentOuter.cabjaks.id = objectID;
		componentOuter.cabjaks.componentOptions = componentOptions;
		componentOuter.cabjaks.productID = currentProductID;
		componentOuter.cabjaks.variantID = currentVariantID;
		componentOuter.cabjaks.image = currentProductImageUrl;
		componentOuter.cabjaks.image2x = currentProductImageUrl2x;
		componentOuter.cabjaks.price = currentProductPrice;
		componentOuter.cabjaks.drawers = drawers;
		componentOuter.cabjaks.handleCount = componentHandleCount;
		componentOuter.cabjaks.info = componentInfo;
		componentOuter.cabjaks.properties = currentProductProperties;
		componentOuter.cabjaks.snapAreaID = snapAreaID;
		componentOuter.cabjaks.snapAxis = snapAxis;
		componentOuter.cabjaks.forceAxis = forceAxis;
		componentOuter.cabjaks.snapTop = snapTop;
		componentOuter.cabjaks.outerAreaLeft = null;
		componentOuter.cabjaks.outerAreaTop = null;
		componentOuter.cabjaks.outerAreaRight = null;
		componentOuter.cabjaks.outerAreaBottom = null;
        componentOuter.cabjaks.componentType = componentType;
        componentOuter.cabjaks.towerType = towerType;
		componentOuter.cabjaks.subProducts = towerComponentProducts;

		canvas.add(componentOuter);
		objectID++;

		// Update price
		updatePrice();

		// Update summary list
		updateSummary();

		componentAddedCount++;

		if(componentAddedCount > 2 && componentSelectedCount > 2) {
			progressInstructions = true;
		}

		// Show prompt if window closed without saving
		window.onbeforeunload = confirmOnPageExit;

		return componentOuter;
	}

	// Add a component
	function addComponent($component) {
		// Update current product
		currentProductID = $component.data('id');
		currentProduct = window['product' + currentProductID];
		currentProductPrice = currentProduct.price;

		// Clear old product info
		currentVariantID = null;
		currentVariant = null;
		componentWidth = null;
		componentDepth = null;
		componentHeight = null;
		componentDrawers = 0;
		componentShelves = 0;
		componentHandleCount = 0;
		componentType = null;
		towerType = null;

		// Unselect old product
		onDeselect();

		// Get static component info (if width/height are selectable then this is saved later)
		if($component.data('width')) {
			componentWidth = parseInt($component.data('width'), 10);
		}

		if($component.data('depth')) {
			componentDepth = parseInt($component.data('depth'), 10);
		}

		if($component.data('height')) {
			componentHeight = parseInt($component.data('height'), 10);
		}

		if($component.data('category')) {
			componentType = $component.data('category');
		}

		// Figure out tower type if needed
		if(componentType == 'Towers') {
			// If tower has drawers and handles
			if(currentProduct.title.indexOf('Drawers and Handles') > -1) {
				towerType = 'Drawers and Handles';

			// If tower has drawers
			} else if(currentProduct.title.indexOf('Drawers') > -1) {
				towerType = 'Drawers';

			// If standard tower
			} else {
				towerType = 'Shelves';
			}
		}

		// If product has multiple options, show options popup
		if(currentProduct.variants.length > 1 || componentType == 'Towers') {
			showProductOptions();

		// Otherwise just add it
		} else {
			// Find variant ID (required for add to cart)
			if(currentProduct.variants.length == 1) {
				currentVariant = currentProduct.variants[0];
				currentVariantID = currentVariant.id;

				// Create component
				if(componentWidth && componentHeight) {
					createComponent(componentWidth, componentDepth, componentHeight, componentDrawers, componentShelves, componentType, towerType);

					// Hide drag instructions after the first component is dropped
					dragInstructions = false;
					$step2.find('.step-error').removeClass('shown');

					// Hide options in case they were shown already
					hideProductOptions();
				}
			}
		}
	}

	// Delete a component
	function deleteComponent(previousID, preserveUpgradeState) {
    	preserveUpgradeState = preserveUpgradeState === true;
		var component = canvas.getActiveObject(),
		drawers = component.cabjaks.drawers,
		handleCount = component.cabjaks.handleCount,
		selectedType = component.cabjaks.componentType,
		subProducts = component.cabjaks.subProducts,
		subProductID = null,
		subProductQuantity = null,
		subProductProperties = {},
		oldSuggestedRailSupports = suggestedRailSupports,
		oldSuggestedShelfSupports = suggestedShelfSupports;

		// Remove from canvas
		canvas.remove(canvas.getActiveObject());

		// Delete tower
		if(selectedType == 'Towers') {
			// Loop through tower components
			for(var j = 0; j < subProducts.length; j++) {
				subProductID = subProducts[j].id;
				subProductQuantity = subProducts[j].quantity;
				subProductProperties = subProducts[j].properties;

				// Remove/update component in summary list
				for(var i = 0; i < addtoCartQueue.length; i++) {
					// Find variant in summary list
					if(addtoCartQueue[i].id == subProductID) {
						// Make sure properties also match
						if(JSON.stringify(addtoCartQueue[i].properties) === JSON.stringify(subProductProperties)) {
							// Update shelf supports
							if(addtoCartQueue[i].title == 'Shelf') {
								suggestedShelfSupports = suggestedShelfSupports - (subProductQuantity * 4);
							}

							// Remove product if the quantity matches or would become less than 1
							if(addtoCartQueue[i].quantity == subProductQuantity || addtoCartQueue[i].quantity - subProductQuantity < 1) {
								addtoCartQueue.splice(i, 1);

							// Otherwise update to new quantity
							} else {
								var componentQuantity = addtoCartQueue[i].quantity - subProductQuantity,
								linePrice = addtoCartQueue[i].price * componentQuantity,
								linePriceFormatted = Shopify.formatMoney(linePrice, moneyFormat);

								addtoCartQueue[i].quantity = componentQuantity;
								addtoCartQueue[i].line_price = linePrice;
								addtoCartQueue[i].line_price_formatted = linePriceFormatted;
							}

							break;
						}
					}

					// Find prev variant in summary list
					if(previousID) {
						if(addtoCartQueue[i].id == previousID) {
							// Make sure properties also match
							if(JSON.stringify(addtoCartQueue[i].properties) === JSON.stringify(subProductProperties)) {
								// Update shelf supports
								if(addtoCartQueue[i].title == 'Shelf') {
									suggestedShelfSupports = suggestedShelfSupports - (subProductQuantity * 4);
								}

								// Remove product if the quantity matches or would become less than 1
								if(addtoCartQueue[i].quantity == subProductQuantity || addtoCartQueue[i].quantity - subProductQuantity < 1) {
									addtoCartQueue.splice(i, 1);

								// Otherwise update to new quantity
								} else {
									var componentQuantity = addtoCartQueue[i].quantity - subProductQuantity,
									linePrice = addtoCartQueue[i].price * componentQuantity,
									linePriceFormatted = Shopify.formatMoney(linePrice, moneyFormat);

									addtoCartQueue[i].quantity = componentQuantity;
									addtoCartQueue[i].line_price = linePrice;
									addtoCartQueue[i].line_price_formatted = linePriceFormatted;
								}

								break;
							}
						}
					}
				}
			}

			// Update total handles
			totalHandles = totalHandles - handleCount;

			// Update handle upgrade quantity if needed
			if(handleUpgradeChosen) {
				for(var i = 0; i < addtoCartQueue.length; i++) {
					// Find in summary list
					if(addtoCartQueue[i].title == handleUpgradeTitle) {
						// Remove product if needed
						if(totalHandles == 0) {
							addtoCartQueue.splice(i, 1);

						// Update to new quantity
						} else {
							addtoCartQueue[i].quantity = totalHandles;
							addtoCartQueue[i].line_price = handleUpgradePrice * totalHandles;
							addtoCartQueue[i].line_price_formatted = Shopify.formatMoney(handleUpgradePrice * totalHandles, moneyFormat);
						}

						break;
					}
				}
			}

			// Hide handle choice
			if(totalHandles == 0) {
				$handleSelection.removeClass('shown');
				handleUpgradeChosen = false;

				// Unselect handle choice
				$handleSelection.find('.choice').removeClass('selected');
			}

			// Update handle upgrade price
			$handleUpgradePrice.each(function() {
				$(this).html(Shopify.formatMoney(($(this).data('price')) * totalHandles));
			})

			// Soft close

			// Update total drawer counts
			totalDrawers = totalDrawers - drawers;

			// Hide and reset the soft-close choice only when the drawers
			// are actually being deleted, not while a tower is being edited.
			if(totalDrawers == 0 && !preserveUpgradeState) {
    			$softCloseSelection.removeClass('shown');
    			softCloseUpgradeChosen = false;
    			softCloseStandardChosen = false;

    			// Unselect soft close choice
    			$softCloseSelection.find('.choice').removeClass('selected');
			}

			// Update soft close price
			$softClosePrice.html(Shopify.formatMoney(softCloseUpgradePrice * totalDrawers));

		// Delete normal component
		} else {
			// Remove/update component in summary list
			for(var i = 0; i < addtoCartQueue.length; i++) {
				// Find variant in summary list
				if(addtoCartQueue[i].id == currentVariantID) {
					// Make sure properties also match
					if(JSON.stringify(addtoCartQueue[i].properties) === JSON.stringify(currentProductProperties)) {
						// Update rail supports
						if(addtoCartQueue[i].title == 'Hanging Rail') {
							suggestedRailSupports = suggestedRailSupports - 1;
						}

						// Remove product if there's only one or would become less than 1
						if(addtoCartQueue[i].quantity == 1 || addtoCartQueue[i].quantity - 1 < 1) {
							addtoCartQueue.splice(i, 1);

						// Otherwise update to new quantity
						} else {
							var componentQuantity = addtoCartQueue[i].quantity - 1,
							linePrice = currentProductPrice * componentQuantity,
							linePriceFormatted = Shopify.formatMoney(linePrice, moneyFormat);

							addtoCartQueue[i].quantity = componentQuantity;
							addtoCartQueue[i].line_price = linePrice;
							addtoCartQueue[i].line_price_formatted = linePriceFormatted;
						}

						break;
					}
				}

				// Find prev variant in summary list
				if(previousID) {
					if(addtoCartQueue[i].id == previousID) {
						// Make sure properties also match
						if(JSON.stringify(addtoCartQueue[i].properties) === JSON.stringify(subProductProperties)) {
							// Update shelf supports
							if(addtoCartQueue[i].title == 'Shelf') {
								suggestedShelfSupports = suggestedShelfSupports - 1;
							}

							// Remove product if the quantity matches or would become less than 1
							if(addtoCartQueue[i].quantity == subProductQuantity || addtoCartQueue[i].quantity - 1 < 1) {
								addtoCartQueue.splice(i, 1);

							// Otherwise update to new quantity
							} else {
								var componentQuantity = addtoCartQueue[i].quantity - 1,
								linePrice = currentProductPrice * componentQuantity,
								linePriceFormatted = Shopify.formatMoney(linePrice, moneyFormat);

								addtoCartQueue[i].quantity = componentQuantity;
								addtoCartQueue[i].line_price = linePrice;
								addtoCartQueue[i].line_price_formatted = linePriceFormatted;
							}

							break;
						}
					}
				}
			}
		}

		// Only remove supports if the person hasn't manually changed the support counts
		if(!suggestedSupportsChanged) {
			// Update automatic support quantities
			if (
				oldSuggestedRailSupports !== suggestedRailSupports ||
				oldSuggestedShelfSupports !== suggestedShelfSupports
			) {
				updateSuggestedSupportCards();
			}
			
		}

		// Update price
		updatePrice();

		// Update summary list
		updateSummary();
	}

	// Calculate the mix of 20- and 50-support bags.
	// Prefer the fewest spare supports, then the fewest bags.
		function calculateShelfSupportBags(requiredSupports) {
			var required = Math.max(
				0,
				Math.ceil(Number(requiredSupports) || 0)
			);

			var best = null;

			for (var bags50 = 0; bags50 <= Math.ceil(required / 50); bags50++) {
				var bags20 = Math.ceil(
					Math.max(0, required - bags50 * 50) / 20
				);

				var supplied = bags20 * 20 + bags50 * 50;
				var bagCount = bags20 + bags50;

				if (
					best === null ||
					supplied < best.supplied ||
					(supplied === best.supplied && bagCount < best.bagCount)
				) {
					best = {
						bags20: bags20,
						bags50: bags50,
						supplied: supplied,
						bagCount: bagCount
					};
				}
			}

			return best;
		}

		// Apply automatic quantities to the separate support cards
		function updateSuggestedSupportCards() {
			if (suggestedSupportsChanged) return;

			var bags = calculateShelfSupportBags(suggestedShelfSupports);
			var shelfRows = [];
			var found20 = false;
			var found50 = false;

			$additionalComponents.find('.shelf-supports[data-variant-id]').each(function() {
				var $row = $(this);
				var variantTitle = $row.find('.component-variant').text().trim();
				var packSize = null;

				if (/\b20\b/.test(variantTitle)) {
					packSize = 20;
					found20 = true;
				} else if (/\b50\b/.test(variantTitle)) {
					packSize = 50;
					found50 = true;
				}

				shelfRows.push({
					row: $row,
					packSize: packSize
				});
			});

			// Avoid applying an incomplete combination
			if (
				(bags.bags20 > 0 && !found20) ||
				(bags.bags50 > 0 && !found50)
			) {
				console.warn('Could not find the required shelf support bag cards.');
				return;
			}

			$.each(shelfRows, function(index, entry) {
				if (!entry.packSize) return;

				var quantity = entry.packSize === 20
					? bags.bags20
					: bags.bags50;

				var $input = entry.row.find('input[name=quantity]');
				$input.val(quantity);

				updateAdditionalComponent($input);
			});

			$additionalComponents.find('.rail-supports[data-variant-id]').each(function() {
				var $input = $(this).find('input[name=quantity]');
				$input.val(Math.max(0, suggestedRailSupports));

				updateAdditionalComponent($input);
			});
		}

	// Additional components
	function updateAdditionalComponent($this, updateVariantPrice) {
		// extras have a separate quantity for each variant
			var $extraRow = $this.closest('.cart__row');
			var extraVariantID = $extraRow.attr('data-variant-id');

			if (extraVariantID) {
				var extraProduct = window['product' + $extraRow.data('id')];

				if (!extraProduct) return;

				var extraVariant = null;

				for (var v = 0; v < extraProduct.variants.length; v++) {
					if (String(extraProduct.variants[v].id) === String(extraVariantID)) {
						extraVariant = extraProduct.variants[v];
						break;
					}
				}

				if (!extraVariant) return;

				var extraQuantity = Math.max(
					0,
					parseInt($extraRow.find('input[name=quantity]').val(), 10) || 0
				);

				$extraRow.find('input[name=quantity]').val(extraQuantity);

				// Identify back supports, which can also be included in towers.
				var isBackSupportVariant = backSupportProduct &&
					backSupportProduct.variants.some(function(variant) {
						return String(variant.id) === String(extraVariant.id);
					});

				// Remove the previous entry for this accessory variant.
				for (var q = addtoCartQueue.length - 1; q >= 0; q--) {
					var existingItem = addtoCartQueue[q];

					if (String(existingItem.id) !== String(extraVariant.id)) {
						continue;
					}

					var isMarkedExtra = existingItem.isAdditionalComponent === true;

					// Older saved accessories may not have the additional-component flag.
					// Exclude back supports so included tower panels are preserved.
					var isLegacyExtra =
						!isBackSupportVariant &&
						Object.keys(existingItem.properties || {}).length === 0;

					if (isMarkedExtra || isLegacyExtra) {
						addtoCartQueue.splice(q, 1);
					}
				}

				if (extraQuantity > 0) {
					var extraInfo = [];

					if (extraVariant.title !== 'Default Title') {
						extraInfo.push({
							title: extraProduct.options.join(' / '),
							value: extraVariant.title
						});
					}

					var extraImage = extraVariant.featured_image;
					extraImage = extraImage
						? (extraImage.src || extraImage)
						: extraProduct.featured_image;

					addtoCartQueue.push({
						isAdditionalComponent: true,
						id: extraVariant.id,
						title: extraProduct.title.replace('Wardrobe ', ''),
						quantity: extraQuantity,
						price: extraVariant.price,
						price_formatted: Shopify.formatMoney(extraVariant.price, moneyFormat),
						line_price: extraVariant.price * extraQuantity,
						line_price_formatted: Shopify.formatMoney(
							extraVariant.price * extraQuantity,
							moneyFormat
						),
						img: extraImage
							? Shopify.Image.getSizedImageUrl(extraImage, 'medium')
							: noProductImageUrl,
						img2x: extraImage
							? Shopify.Image.getSizedImageUrl(extraImage, 'large') + ' 2x'
							: noProductImageUrl2x,
						info: extraInfo,
						properties: {}
					});
				}

				updatePrice();
				updateSummary();
				window.onbeforeunload = confirmOnPageExit;

				return;
			}
		var updateVariantPrice = (typeof updateVariantPrice === 'undefined') ? false : updateVariantPrice,
		$componentItem = $this.closest('.cart__row'),
		priceToUpdate = $componentItem.find('select.variant-selector option:selected').data('price'),
		quantity = parseInt($componentItem.find('input[name=quantity]').val(), 10),
		componentID = $componentItem.data('id'),
		componentProduct = window['product' + componentID],
		componentTitle = componentProduct.title.replace('Wardrobe ', ''),
		componentVariant = null,
		componentVariantID = null,
		componentInfo = [];

		// Update variant price if select changed
		if(updateVariantPrice) {
			$componentItem.find('p.price').html(priceToUpdate);
		}

		// Loop through existing summary products, remove existing component
		for(var i = 0; i < addtoCartQueue.length; i++) {
			// If the component already exists
			if(addtoCartQueue[i].title == componentTitle) {
				// Remove old item
				addtoCartQueue.splice(i, 1);
				break;
			}
		}

		// Add to summary list
		if(quantity > 0) {
			if(componentProduct.variants.length > 1) {
				// Get variant ID from select
				componentVariantID = parseInt($componentItem.find('select.variant-selector').val(), 10);

				if(componentVariantID) {
					// Find variant object
					for(var i = 0; i < componentProduct.variants.length; i++) {
						if(componentProduct.variants[i].id == componentVariantID) {
							componentVariant = componentProduct.variants[i];
						}
					}

					componentInfo.push({
						title: componentProduct.options[0], // Use first option title
						value: componentVariant.title
					});
				}

			// Only one variant
			} else {
				componentVariant = componentProduct.variants[0];
			}

			// If component found
			if(componentVariant) {
				if(componentProduct.featured_image) {
					componentImageUrl = Shopify.Image.getSizedImageUrl(componentProduct.featured_image, 'medium');
					componentImageUrl2x = Shopify.Image.getSizedImageUrl(componentProduct.featured_image, 'large') + ' 2x';
				} else {
					componentImageUrl = noProductImageUrl;
					componentImageUrl2x = noProductImageUrl2x;
				}

				addtoCartQueue.push({
					id: componentVariant.id,
					title: componentTitle,
					quantity: quantity,
					price: componentVariant.price,
					price_formatted: Shopify.formatMoney(componentVariant.price, moneyFormat),
					line_price: componentVariant.price * quantity,
					line_price_formatted: Shopify.formatMoney(componentVariant.price * quantity, moneyFormat),
					img: componentImageUrl,
					img2x: componentImageUrl2x,
					info: componentInfo,
					properties: {}
				});
			}
		}

		// Update price
		updatePrice();

		// Update summary list
		updateSummary();
	}

	// Remove components which are off the page
	function cleanUp() {
		// Loop through objects
		canvas.forEachObject(function(obj) {
			var objectLeft = obj.getLeft(),
			objectRight = objectLeft + obj.getWidth() + 1, // Because of group
			objectTop = obj.getTop(),
			objectBottom = objectTop + obj.getHeight() + 1; // Because of group

			// Delete component if it's completely off canvas
			if(objectRight <= 0 || objectLeft >= roomWidth || objectBottom <= 0 || objectTop >= roomHeight) {
				canvas.setActiveObject(obj);
				deleteComponent();
			}
		});
	}

	function swapDrawers(toSoftClose) {
		var toSoftClose = (typeof toSoftClose === 'undefined') ? true : toSoftClose;

		if(totalDrawers > 0 && drawerProduct && drawerHandleProduct && softCloseProduct && softCloseHandleProduct) {

			// If swapping to soft close
			if(toSoftClose) {

				// Loop through all canvas products, swap drawer type in tower sub-products
				canvas.forEachObject(function(obj) {
					// Only if tower
					if(obj.cabjaks.componentType == 'Towers') {
						// Loop through tower components
						for(var i = 0; i < obj.cabjaks.subProducts.length; i++) {
							// Without handle
							for(var j = 0; j < drawerProduct.variants.length; j++) {
								// If standard ID, swap to soft close ID
								if(obj.cabjaks.subProducts[i].id == drawerProduct.variants[j].id) {
									obj.cabjaks.subProducts[i].id = softCloseProduct.variants[j].id;
									break;
								}
							}

							// With handle
							for(var j = 0; j < drawerHandleProduct.variants.length; j++) {
								// If standard ID, swap to soft close ID
								if(obj.cabjaks.subProducts[i].id == drawerHandleProduct.variants[j].id) {
									obj.cabjaks.subProducts[i].id = softCloseHandleProduct.variants[j].id;
									break;
								}
							}
						}
					}
				});

				// Loop through existing summary products, swap drawers to soft close
				for(var i = 0; i < addtoCartQueue.length; i++) {
					if(addtoCartQueue[i].title == 'Drawer' || addtoCartQueue[i].title == 'Drawer - Handleless') {
						for(var j = 0; j < softCloseProduct.variants.length; j++) {
							// Find drawer variant ID
							if(addtoCartQueue[i].id == drawerProduct.variants[j].id) {
								// Match related soft close, check variant title matches (it should if the variants are in the same order)
								if(drawerProduct.variants[j].title == softCloseProduct.variants[j].title) {
									// Swap info to soft close
									addtoCartQueue[i].id = softCloseProduct.variants[j].id;
									addtoCartQueue[i].title = softCloseProduct.title.replace('Wardrobe ', '');
									addtoCartQueue[i].price = softCloseProduct.variants[j].price;
									addtoCartQueue[i].price_formatted = Shopify.formatMoney(softCloseProduct.variants[j].price, moneyFormat);
									addtoCartQueue[i].line_price = softCloseProduct.variants[j].price * addtoCartQueue[i].quantity;
									addtoCartQueue[i].line_price_formatted = Shopify.formatMoney(softCloseProduct.variants[j].price * addtoCartQueue[i].quantity, moneyFormat);
									addtoCartQueue[i].img = Shopify.Image.getSizedImageUrl(softCloseProduct.featured_image, 'medium');
									addtoCartQueue[i].img2x = Shopify.Image.getSizedImageUrl(softCloseProduct.featured_image, 'large') + ' 2x';
								}
								break;
							}
						}
					} else if(addtoCartQueue[i].title == 'Drawer with Handle') {
						for(var j = 0; j < softCloseHandleProduct.variants.length; j++) {
							// Find drawer variant ID
							if(addtoCartQueue[i].id == drawerHandleProduct.variants[j].id) {
								// Match related soft close, check variant title matches (it should if the variants are in the same order)
								if(drawerHandleProduct.variants[j].title == softCloseHandleProduct.variants[j].title) {
									// Swap info to soft close
									addtoCartQueue[i].id = softCloseHandleProduct.variants[j].id;
									addtoCartQueue[i].title = softCloseHandleProduct.title.replace('Wardrobe ', '');
									addtoCartQueue[i].price = softCloseHandleProduct.variants[j].price;
									addtoCartQueue[i].price_formatted = Shopify.formatMoney(softCloseHandleProduct.variants[j].price, moneyFormat);
									addtoCartQueue[i].line_price = softCloseHandleProduct.variants[j].price * addtoCartQueue[i].quantity;
									addtoCartQueue[i].line_price_formatted = Shopify.formatMoney(softCloseHandleProduct.variants[j].price * addtoCartQueue[i].quantity, moneyFormat);
									addtoCartQueue[i].img = Shopify.Image.getSizedImageUrl(softCloseHandleProduct.featured_image, 'medium');
									addtoCartQueue[i].img2x = Shopify.Image.getSizedImageUrl(softCloseHandleProduct.featured_image, 'large') + ' 2x';
								}
								break;
							}
						}
					}
				}

			// If swapping to standard
			} else {

				// Loop through all canvas products, swap drawer type in tower sub-products
				canvas.forEachObject(function(obj) {
					// Only if tower
					if(obj.cabjaks.componentType == 'Towers') {
						// Loop through tower components
						for(var i = 0; i < obj.cabjaks.subProducts.length; i++) {
							// Without handle
							for(var j = 0; j < softCloseProduct.variants.length; j++) {
								// If soft close ID, swap to standard ID
								if(obj.cabjaks.subProducts[i].id == softCloseProduct.variants[j].id) {
									obj.cabjaks.subProducts[i].id = drawerProduct.variants[j].id;
									break;
								}
							}

							// With handle
							for(var j = 0; j < softCloseHandleProduct.variants.length; j++) {
								// If soft close ID, swap to standard ID
								if(obj.cabjaks.subProducts[i].id == softCloseHandleProduct.variants[j].id) {
									obj.cabjaks.subProducts[i].id = drawerHandleProduct.variants[j].id;
									break;
								}
							}
						}
					}
				});

				// Loop through existing summary products, swap drawers to soft close
				for(var i = 0; i < addtoCartQueue.length; i++) {
					if(addtoCartQueue[i].title == 'Soft Close Drawer' || addtoCartQueue[i].title == 'Soft Close Drawer - Handleless') {
						for(var j = 0; j < drawerProduct.variants.length; j++) {
							// Find drawer variant ID
							if(addtoCartQueue[i].id == softCloseProduct.variants[j].id) {
								// Match related standard drawer, check variant title matches (it should if the variants are in the same order)
								if(softCloseProduct.variants[j].title == drawerProduct.variants[j].title) {
									// Swap info to standard drawer
									addtoCartQueue[i].id = drawerProduct.variants[j].id;
									addtoCartQueue[i].title = drawerProduct.title.replace('Wardrobe ', '');
									addtoCartQueue[i].price = drawerProduct.variants[j].price;
									addtoCartQueue[i].price_formatted = Shopify.formatMoney(drawerProduct.variants[j].price, moneyFormat);
									addtoCartQueue[i].line_price = drawerProduct.variants[j].price * addtoCartQueue[i].quantity;
									addtoCartQueue[i].line_price_formatted = Shopify.formatMoney(drawerProduct.variants[j].price * addtoCartQueue[i].quantity, moneyFormat);
									addtoCartQueue[i].img = Shopify.Image.getSizedImageUrl(drawerProduct.featured_image, 'medium');
									addtoCartQueue[i].img2x = Shopify.Image.getSizedImageUrl(drawerProduct.featured_image, 'large') + ' 2x';
								}
								break;
							}
						}
					} else if(addtoCartQueue[i].title == 'Soft Close Drawer with Handle') {
						for(var j = 0; j < drawerHandleProduct.variants.length; j++) {
							// Find drawer variant ID
							if(addtoCartQueue[i].id == softCloseHandleProduct.variants[j].id) {
								// Match related soft close, check variant title matches (it should if the variants are in the same order)
								if(softCloseHandleProduct.variants[j].title == drawerHandleProduct.variants[j].title) {
									// Swap info to soft close
									addtoCartQueue[i].id = drawerHandleProduct.variants[j].id;
									addtoCartQueue[i].title = drawerHandleProduct.title.replace('Wardrobe ', '');
									addtoCartQueue[i].price = drawerHandleProduct.variants[j].price;
									addtoCartQueue[i].price_formatted = Shopify.formatMoney(drawerHandleProduct.variants[j].price, moneyFormat);
									addtoCartQueue[i].line_price = drawerHandleProduct.variants[j].price * addtoCartQueue[i].quantity;
									addtoCartQueue[i].line_price_formatted = Shopify.formatMoney(drawerHandleProduct.variants[j].price * addtoCartQueue[i].quantity, moneyFormat);
									addtoCartQueue[i].img = Shopify.Image.getSizedImageUrl(drawerHandleProduct.featured_image, 'medium');
									addtoCartQueue[i].img2x = Shopify.Image.getSizedImageUrl(drawerHandleProduct.featured_image, 'large') + ' 2x';
								}
								break;
							}
						}
					}
				}

			}
		}

		// Update price
		updatePrice();

		// Update summary list
		updateSummary();
	}

	// Confirm exit if components added
	var confirmOnPageExit = function(e) {
		// If we haven't been passed the event get the window.event
		e = e || window.event;

		var message = 'Your wardrobe plan has not been saved.';

		// For IE6-8 and Firefox prior to version 4
		if(e) {
			e.returnValue = message;
		}

		// For Chrome, Safari, IE8+ and Opera 12+
		return message;
	};

	// Show read more/less
	function headingDescriptionShorten() {

		var showChar = 125;  // character limit
		var ellipses = '...';
		var moretext = 'Read More';
		var lesstext = 'Read Less';

		var content = $('.saved-plan .description-container .description p').html();

		if(content.length > showChar) {
			var visibleContent = content.substr(0, showChar);
			var hiddenContent = content.substr(showChar, content.length - showChar);
			var html = visibleContent + '<span class="more-ellipses">' + ellipses+ '&nbsp;</span><span class="more-content"><span>' + hiddenContent + '</span>&nbsp;&nbsp;<a href="" class="more-link"><span>' + moretext + '</span></a></span>';
			$('.saved-plan .description-container .description p').html(html);
		}


		$('.more-link span').click(function(){
		if($(this).hasClass('less')) {
			$(this).removeClass('less');
			$(this).html(moretext);
			$('.more-ellipses').show();
		} else {
			$(this).addClass('less');
			$(this).html(lesstext);
			$('.more-ellipses').hide();
		}
		$(this).parent().prev().toggle();
		$(this).prev().toggle();
		return false;
		});
	}

    function bindProgressEvents(){
        // First step next button
        $wardrobePlanner.find('a.create-new-plan').on('click', function(e) {
            e.preventDefault();
            if(totalPlan >= totalAllowed) {
                return swal.fire("You can not add more plans.",`The maximum allowrence for saved plan is ${totalAllowed}.`,"warning");
            }
            // Set up canvas for new plan
            createNewPlan();
        });

        // Next button
        $wardrobePlanner.find('a.next').on('click', function(e) {
            var $this = $(this),
            nextStep = parseInt($this.attr('href').replace('#step-', ''), 10);

            if(validateSteps(nextStep - 1)) {
                goToNextStep(nextStep);
            } else {
                e.preventDefault();
            }
        });

        // Prev button
        $wardrobePlanner.find('a.btn-prev').on('click', function(e) {
            var $this = $(this),
            prevStep = parseInt($this.attr('href').replace('#step-', ''), 10);

            if(validateSteps(prevStep - 1)) {
                goToNextStep(prevStep);
            } else {
                e.preventDefault();
            }
        });

        // Progress navigation
        $progress.find('a').on('click', function(e) {
            var $this = $(this),
            $parentLi = $this.parent('li'),
            index = $this.closest('ul').find('li').index($parentLi);

            if($parentLi.hasClass('available') && !$parentLi.hasClass('current')) {
                // Need to validate if jumping forward
                if(validateSteps(index)) {
                    currentStep = index + 1;
                    updateProgress();
                } else {
                    e.preventDefault();
                }

            } else {
                e.preventDefault();
            }
        });

        // On forwards/back click
        $(window).on('hashchange', function(e) {

            // Get hash from URL, replace '#' with '.'
            var newStep = location.hash.replace(/^#step-/, '');

            // Only do something if the hash is different
            if(newStep != currentStep) {

                // If blank, go to first step
                if(newStep == "") {
                    newStep = 1;
                }

                // Check if step is available
                if(newStep <= stepProgress) {
                    if(validateSteps(newStep - 1)) {
                        currentStep = newStep;
                        updateProgress();
                    } else {
                        e.preventDefault();
                    }
                }
            }
        });
    }

    function bindLoginFormEvents(){
        // Login form submit
		$login.find('form').find('.btn-login').on('click', function(e) {
			var $this = $login.find('form'),
            $loginButton = $this.find('button.btn-login'),
            $formError = $this.find('.form-error'),
            $email = $this.find('input#login-email'),
            $password = $this.find('input#login-password'),
            sendForm = true;

            e.preventDefault();

            // Clear old errors
            $formError.removeClass('shown').empty();
            $email.removeClass('error');
            $password.removeClass('error');

            if($email.val() == '') {
                addFormError($email, 'Please enter your email address.');
                sendForm = false;

            } else if(!$email.val().match(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/)) {
                addFormError($email, 'Please check your email address is valid.');
                sendForm = false;
            }

            if($password.val() == '') {
                addFormError($password, 'Please enter a password.');
                sendForm = false;
            }

            if(sendForm) {
                $loginButton.prop('disabled', true).addClass('is-loading');

                // Send login form
                $.ajax({
                    method: 'POST',
                    url: '/account/login',
                    data: $this.serialize(),
                    dataType: 'html',
                    timeout: 15000,
                    cache: false
                }).done(function(response) {
                    var $response = $(response),
                    $responseTextLinks = $response.find('.site-header--text-links'),
                    $responseMobileLinks = $response.find('.mobile-customer-nav'),
                    $responseDesktopLinks = $response.find('.header-content .account-links'),
                    $responsePlanOptions = $response.find('select#plan-to-load').children(),
                    $responseCustomerID = $response.find('#ajax-customer-id'),
                    $responsePlanID = $response.find('#ajax-plan-id'),
                    responsePlanTitle = $response.find('input#plan-title').val(),
                    customerIDFound = false,
                    planIDFound = false;
					customerTags = $response.find('[data-customer-tags]').data('customerTags');

                    // Done loading
                    $loginButton.prop('disabled', false).removeClass('is-loading');

                    // Invalid password
                    if(response.indexOf('Invalid login credentials') !== -1) {
                        $formError.addClass('shown').html('Invalid login credentials.');
                    // Success
                    } else {
                        // Update customer ID
                        if($responseCustomerID.length) {
                            if($responseCustomerID.val()) {
                                customerID = $responseCustomerID.val();
                                customerIDFound = true;
                            }
                        }

                        // Update plan ID
                        if($responsePlanID.length) {
                            if($responsePlanID.val()) {
                                planID = $responsePlanID.val();
                                planIDFound = true;
                            }
                        }

						if(customerIDFound){
							$.ajax({
								method: 'POST',
								url: planner_api_url + '/customer/update',
								data: JSON.stringify({
									customer_id: customerID,
									customer_tag: $this.find('select#register-customer-type').val()
								}),
								timeout: 15000,
								cache: false,
								contentType: "application/json"
							})
						}
						
                        if(customerIDFound && planIDFound) {
                            // Show logged in as
                            if($responseTextLinks.length) {
                                $('.site-header--text-links').replaceWith($responseTextLinks);
                            }

                            // Show logged in as (mobile)
                            if($responseMobileLinks.length) {
                                $('.mobile-customer-nav').replaceWith($responseMobileLinks);
                            }

                            // Show logged in (desktop)
                            if($responseDesktopLinks.length){
                                $('.header-content .account-links').replaceWith($responseDesktopLinks);
                            }

                            // Load plans into select
                            if($responsePlanOptions.length) {
                                $planToLoad.empty().append($responsePlanOptions);
                            }

                            // Update plan title
                            if(responsePlanTitle) {
                                $planTitle.val(responsePlanTitle);
                            }

                            // Hide login box
                            $customerForm.removeClass('shown');
                            $fullOverlay.removeClass('shown');

                            // If save button was clicked without being logged in
                            if(savePlanAfterLogin) {
                                savePlan();

                            // If load button was clicked without being logged in
                            } else {
                                // Start the load
                                findPlanToLoad();
                            }
                        } else {
                            // Try loading page again (because IE is 'special')
                            $loginButton.prop('disabled', true).addClass('is-loading');

                            $.ajax({
                                url: '/collections/wardrobe-planner',
                                timeout: 15000,
                                cache: false
                            }).done(function(response) {
                                var $response = $(response),
                                $responseTextLinks = $response.find('.site-header--text-links'),
                                $responseMobileLinks = $response.find('.mobile-customer-nav'),
                                $responseDesktopLinks = $response.find('.header-content .account-links'),
                                $responsePlanOptions = $response.find('select#plan-to-load').children(),
                                $responseCustomerID = $response.find('#ajax-customer-id'),
                                $responsePlanID = $response.find('#ajax-plan-id'),
                                responsePlanTitle = $response.find('input#plan-title').val(),
                                customerIDFound = false,
                                planIDFound = false;

                                // Update customer ID
                                if($responseCustomerID.length) {
                                    if($responseCustomerID.val()) {
                                        customerID = $responseCustomerID.val();
                                        customerIDFound = true;
                                    }
                                }

                                // Update plan ID
                                if($responsePlanID.length) {
                                    if($responsePlanID.val()) {
                                        planID = $responsePlanID.val();
                                        planIDFound = true;
                                    }
                                }

                                if(customerIDFound && planIDFound) {
                                    // Show logged in as
                                    if($responseTextLinks.length) {
                                        $('.site-header--text-links').replaceWith($responseTextLinks);
                                    }

                                    // Show logged in as (mobile)
                                    if($responseMobileLinks.length) {
                                        $('.mobile-customer-nav').replaceWith($responseMobileLinks);
                                    }

                                    // Show logged in (desktop)
                                    if($responseDesktopLinks.length){
                                        $('.header-content .account-links').replaceWith($responseDesktopLinks);
                                    }

                                    // Load plans into select
                                    if($responsePlanOptions.length) {
                                        $planToLoad.empty().append($responsePlanOptions);
                                    }

                                    // Update plan title
                                    if(responsePlanTitle) {
                                        $planTitle.val(responsePlanTitle);
                                    }

                                    // Hide login box
                                    $customerForm.removeClass('shown');
                                    $fullOverlay.removeClass('shown');

                                    // If save button was clicked without being logged in
                                    if(savePlanAfterLogin) {
                                        savePlan();

                                    // If load button was clicked without being logged in
                                    } else {
                                        // Start the load
                                        findPlanToLoad();
                                    }
                                } else {
                                    $formError.addClass('shown').html('Error loading customer information, please try again.');
                                }
                            }).fail(function() {
                                $formError.addClass('shown').html('Error logging in, please try again.');
                            }).always(function() {
                                $loginButton.prop('disabled', false).removeClass('is-loading');
                            });
                        }
                    }
                }).fail(function() {
                    $loginButton.prop('disabled', false).removeClass('is-loading');
                    $formError.addClass('shown').html('Error logging in, please try again.');
                });
            }
        });

        // Login form cancel
        $login.find('.action-buttons a.cancel').on('click', function(e) {
            e.preventDefault();

            // Close popup
            hideLogin();
        });

        // Show register screen
        $login.find('a.go-to').on('click', function(e) {
            e.preventDefault();

            $login.removeClass('shown');
            $register.addClass('shown');
        });

        // Register form submit
		$register.find('form').find('.btn-register').on('click', function(e) {
			var $this = $register.find('form'),
            $registerButton = $this.find('button.btn-register'),
            $formError = $this.find('.form-error'),
            $firstName = $this.find('input#register-first-name'),
            $lastName = $this.find('input#register-last-name'),
            $email = $this.find('input#register-email'),
            $password = $this.find('input#register-password'),
            sendForm = true;

            e.preventDefault();

            // Clear old errors
            $formError.removeClass('shown').empty();
            $firstName.removeClass('error');
            $lastName.removeClass('error');
            $email.removeClass('error');
            $password.removeClass('error');

            if($firstName.val() == '') {
                addFormError($firstName, 'Please enter your first name.');
                sendForm = false;
            }

            if($lastName.val() == '') {
                addFormError($lastName, 'Please enter your last name.');
                sendForm = false;
            }

            if($email.val() == '') {
                addFormError($email, 'Please enter your email address.');
                sendForm = false;

            } else if(!$email.val().match(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/)) {
                addFormError($email, 'Please check your email address is valid.');
                sendForm = false;
            }

            if($password.val() == '') {
                addFormError($password, 'Please enter a password.');
                sendForm = false;
            } else if($password.val().length < 5) {
                addFormError($password, 'The password is too short (minimum is 5 characters).');
                sendForm = false;
            }

            if(sendForm) {
                $registerButton.prop('disabled', true).addClass('is-loading');

                // Send login form
                $.ajax({
                    method: 'POST',
                    url: '/account',
                    data: $this.serialize(),
                    dataType: 'html',
                    timeout: 15000,
                    cache: false
                }).done(function(response) {
                    var $response = $(response),
                    $responseTextLinks = $response.find('.site-header--text-links'),
                    $responseMobileLinks = $response.find('.mobile-customer-nav'),
                    $responseDesktopLinks = $response.find('.header-content .account-links'),
                    $responseCustomerID = $response.find('#ajax-customer-id'),
                    $responsePlanID = $response.find('#ajax-plan-id'),
                    responsePlanTitle = $response.find('input#plan-title').val(),
                    customerIDFound = false,
                    planIDFound = false;
					customerTags = $response.find('[data-customer-tags]').data('customerTags');

                    // Done loading
                    $registerButton.prop('disabled', false).removeClass('is-loading');

                    // Invalid email
                    if(response.indexOf('email is invalid') !== -1) {
                        $formError.addClass('shown').html('Please check your email address is valid.');

                    // Success
                    } else {
                        // Update customer ID
                        if($responseCustomerID.length) {
                            if($responseCustomerID.val()) {
                                customerID = $responseCustomerID.val();
                                customerIDFound = true;
                            }
                        }

                        // Update plan ID
                        if($responsePlanID.length) {
                            if($responsePlanID.val()) {
                                planID = $responsePlanID.val();
                                planIDFound = true;
                            }
                        }

                        if(customerIDFound && planIDFound) {
                            // Show logged in as
                            if($responseTextLinks.length) {
                                $('.site-header--text-links').replaceWith($responseTextLinks);
                            }

                            // Show logged in as (mobile)
                            if($responseMobileLinks.length) {
                                $('.mobile-customer-nav').replaceWith($responseMobileLinks);
                            }

                            // Show logged in (desktop)
                            if($responseDesktopLinks.length){
                                $('.header-content .account-links').replaceWith($responseDesktopLinks);
                            }

                            // Update plan title
                            if(responsePlanTitle) {
                                $planTitle.val(responsePlanTitle);
                            }

                            // Hide login box
                            $customerForm.removeClass('shown');
                            $fullOverlay.removeClass('shown');

                            // Save plan
                            savePlan();
                        } else {
                            // Try loading page again (because IE is 'special')
                            $registerButton.prop('disabled', true).addClass('is-loading');

                            $.ajax({
                                url: '/collections/wardrobe-planner',
                                timeout: 15000,
                                cache: false
                            }).done(function(response) {
                                var $response = $(response),
                                $responseTextLinks = $response.find('.site-header--text-links'),
                                $responseMobileLinks = $response.find('.mobile-customer-nav'),
                                $responseDesktopLinks = $response.find('.header-content .account-links'),
                                $responseCustomerID = $response.find('#ajax-customer-id'),
                                $responsePlanID = $response.find('#ajax-plan-id'),
                                responsePlanTitle = $response.find('input#plan-title').val(),
                                customerIDFound = false,
                                planIDFound = false;

                                // Update customer ID
                                if($responseCustomerID.length) {
                                    if($responseCustomerID.val()) {
                                        customerID = $responseCustomerID.val();
                                        customerIDFound = true;
                                    }
                                }

                                // Update plan ID
                                if($responsePlanID.length) {
                                    if($responsePlanID.val()) {
                                        planID = $responsePlanID.val();
                                        planIDFound = true;
                                    }
                                }

                                if(customerIDFound && planIDFound) {
                                    // Show logged in as
                                    if($responseTextLinks.length) {
                                        $('.site-header--text-links').replaceWith($responseTextLinks);
                                    }

                                    // Show logged in as (mobile)
                                    if($responseMobileLinks.length) {
                                        $('.mobile-customer-nav').replaceWith($responseMobileLinks);
                                    }

                                    // Show logged in (desktop)
                                    if($responseDesktopLinks.length){
                                        $('.header-content .account-links').replaceWith($responseDesktopLinks);
                                    }

                                    // Update plan title
                                    if(responsePlanTitle) {
                                        $planTitle.val(responsePlanTitle);
                                    }

                                    // Hide login box
                                    $customerForm.removeClass('shown');
                                    $fullOverlay.removeClass('shown');

                                    // Save plan
                                    savePlan();
                                } else {
                                    $formError.addClass('shown').html('Error loading customer information, please try again. (An account may already exist with this email address.)');
                                }
                            }).fail(function() {
                                $formError.addClass('shown').html('Error creating account, please try again.');
                            }).always(function() {
                                $registerButton.prop('disabled', false).removeClass('is-loading');
                            });
                        }
                    }
                }).fail(function() {
                    $registerButton.prop('disabled', false).removeClass('is-loading');
                    $formError.addClass('shown').html('Error creating account, please try again.');
                });
            }
        });

        // Register form cancel
        $register.find('.action-buttons a.cancel').on('click', function(e) {
            e.preventDefault();

            // Close popuply
            hideRegister();
        });

    }

    function bindStepOneAndTwoEvents(){

        $savedPlan.find('.choice').on('click', function() {
            var $this = $(this),
            $allChoices = $savedPlan.find('.products-list'),
            choiceText = $this.find('h3').text();

            // Mark choice as selected
            $this.addClass('selected').parent('.grid__item').siblings().find('.choice').removeClass('selected');

            if(choiceText == 'Create New Plan') {
                if(totalPlan >= totalAllowed) {
                    return swal.fire("You can not add more plans.",`The maximum allowrence for saved plan is ${totalAllowed}.`,"warning");
                }
                createNewPlan();
            } else if(choiceText == 'Open Saved Plan') {
                if(customerID) {
                    if(!$allChoices.hasClass('is-loading')) {
                        if(totalPlan > 0) {
                            return window.location.href = '/account';
                        }
                        findPlanToLoad();
                    }
                } else {
                    // Show login popup
                    $fullOverlay.addClass('shown');
                    $customerForm.addClass('shown');
                }
            }
        });

        // Load options submit
        $loadOptions.find('.action-buttons button').on('click', function(e) {
            e.preventDefault();

            planToLoad = $planToLoad.val();

            // Load plan
            loadSavedPlan(true);
        });

        // Load options cancel
        $loadOptions.find('.action-buttons a.cancel').on('click', function(e) {
            e.preventDefault();

            // Close popup
            hideLoadOptions();
        });

        //create new plan from scratch if create new plan tab is clicked
        $wardrobePlanner.find('#createNewPlan').on('click', function(e){
            e.preventDefault();

            if(addtoCartQueue.length > 0){

                // Create new plan
                createNewPlan();

                //clear canvas
                cleanUp();
                canvas.clear();
                $dragInstructions.addClass('shown');
                initCanvas();

                addtoCartQueue = [];

                // Update price
                updatePrice();

                // Update summary list
                updateSummary();

                $progress.find('li').removeClass('current').eq(currentStep - 1 ).removeClass('available current').nextAll().removeClass('available completed');
                $progress.find('li').eq(currentStep).removeClass('available');

            }

        });

        // Allow for enter press on first step
        $roomInputs.on('keydown', function(e) {
            if(e.keyCode == 13) {
                goToNextStepAndValidate(3);
            }
        });
    }

    function bindMessageEvents(){
        // Panel warning submit
        $warning.find('.action-buttons button.btn').on('click', function(e) {
            e.preventDefault();

            // Close popup
            $fullOverlay.removeClass('shown');
            $warning.removeClass('shown');

            // Scroll over to top panel
            $productsList.find('a.scroll-right').trigger('click');

            //scroll to bottom of the wardrobe components product list
            $productsList.find(".range-content .scroll")[0].scrollIntoView(false);

            // Scroll down to product list
            $('html, body').animate({
                scrollTop: $productsList.offset().top - 30
            }, 800);
        });

        // Panel warning cancel
        $warning.find('.action-buttons a.cancel').on('click', function(e) {
            e.preventDefault();

            // Close popup
            hideWarning();
        });
    }

    function bindProductsListEvents(){
        // Drag and drop components to canvas
        $productsList.find('.draggable-product').draggable({
            appendTo: 'body',
            containment: 'body',
            helper: 'clone',
            zIndex: 100
        });

        // Set canvas as droppable
        $diagram.droppable({
            activeClass: 'drag-active',
            accept: '.draggable-product',
            tolerance: 'touch',
            drop: function(e, ui) {
                addComponent(ui.draggable);
            }
        });

        // Scroll products list
        $productsList.find('.scroll').on('scroll', function(e) {
            var $scroll = $(this),
            $leftArrow = $scroll.find('.scroll-left'),
            $rightArrow = $scroll.find('.scroll-right'),
            scrollLeft = $scroll.scrollLeft(),
            buffer = 20;

            // If scrolled all the way to the left
            if(scrollLeft < buffer) {
                $leftArrow.removeClass('shown');
            } else {
                $leftArrow.addClass('shown');
            }

            // If scrolled all the way to the right
            // if(scrollLeft > ($scroll[0].scrollWidth - $scroll[0].offsetWidth) - buffer) {
            // 	$rightArrow.removeClass('shown');
            // } else {
            // 	$rightArrow.addClass('shown');
            // }
        });

    }

    function bindCanvasEvents(){
        // Product options submit
        $productOptions.find('.action-buttons .btn-add').on('click', function(e) {
            e.preventDefault();
            var prevVariantID = currentVariantID

            // Get the selected variant
            currentVariantID = parseInt($productSelect.val(), 10);

            // Loop through product JSON to find the variant info
            for(var i = 0; i < currentProduct.variants.length; i++) {
                if(currentProduct.variants[i].id == currentVariantID) {
                    // Update current variant info
                    currentVariant = currentProduct.variants[i];

                    // Update price for the selected variant
                    currentProductPrice = currentVariant.price;

                    // Loop through options looking for Width / Height values
                    for(var j = 0; j < currentProduct.options.length; j++) {
                        if(currentProduct.options[j] == 'Width') {
                            componentWidth = removeMm(currentVariant['option' + (j + 1)]);

                            // Update default width if tower
                            if(componentType == 'Towers') {
                                defaultTowerWidth = componentWidth;
                            }
                        } else if(currentProduct.options[j] == 'Depth') {
                            componentDepth = removeMm(currentVariant['option' + (j + 1)]);

                            // Update default depth if tower
                            if(componentType == 'Towers') {
                                defaultTowerDepth = componentDepth;
                            }
                        } else if(currentProduct.options[j] == 'Height') {
                            componentHeight = removeMm(currentVariant['option' + (j + 1)]);

                            // Update default height if tower
                            if(componentType == 'Towers') {
                                defaultTowerHeight = componentHeight;
                            }
                        // If size, split into depth and height
                        } else if(currentProduct.options[j] == 'Size') {
                            var componentSize = currentVariant['option' + (j + 1)];
                            componentSize = componentSize.split(' x ');
                            componentDepth = removeMm(componentSize[0]);
                            componentHeight = removeMm(componentSize[1]);
                        }
                    }

                    if(componentType == 'Components' && !componentHeight) {
                        componentHeight = $('[data-id="' + currentProduct.id + '"]').data('height');
                    }
                    // Create component if width and height are available
                    if(componentWidth && componentHeight) {
                        // Get drawer/shelf values from selects if needed
                        if(componentType == 'Towers') {
                            if(towerType == 'Drawers' || towerType == 'Drawers and Handles') {
                                componentDrawers = parseInt($towerDrawersSelect.val(), 10);
                            }
                            componentShelves = parseInt($towerShelvesSelect.val(), 10);
                        }

                        if(isUpdating) {
                            deleteComponent(prevVariantID, true);
                            isUpdating = false;
                            createComponent(componentWidth, componentDepth, componentHeight, componentDrawers, componentShelves, componentType, towerType, updateLeft, updateTop);

                            // Update price
                            updatePrice();
                            // Update summary list
                            updateSummary();
                        } else {
                            // Create component
                            createComponent(componentWidth, componentDepth, componentHeight, componentDrawers, componentShelves, componentType, towerType);
                        }



                        // Hide drag instructions after the first component is dropped
                        dragInstructions = false;
                        $step2.find('.step-error').removeClass('shown');

                        // Close popup
                        hideProductOptions();
                    }

                    break;
                }
            }
        });

        // Product options configure
        $productOptions.find('.action-buttons .btn-configure').on('click', function(e) {
            e.preventDefault();

            var availableHeight = null,
            defaultDrawers = null,
            drawerSpacing = null,
            shelvesStart = null;

            // Reset old selected height
            selectedHeight = null;

            // Calculate height
            $componentOptions.find('.selector-wrapper').each(function() {
                var $selectorWrapper = $(this);

                // Find selected height, drawer options
                if($selectorWrapper.find('label').text() == 'Height') {
                    selectedHeight = removeMm($selectorWrapper.find('select').val());
                    availableHeight = selectedHeight;

                    if(towerType == 'Drawers' || towerType == 'Drawers and Handles') {
                        // Don't put drawers too high up or people won't be able to reach them!
                        if(availableHeight > maxDrawerHeight) {
                            availableHeight = maxDrawerHeight;
                        }

                        if(towerType == 'Drawers') {
                            drawerSpacing = drawerHeight + spaceBetweenDrawers;
                        } else if(towerType == 'Drawers and Handles') {
                            drawerSpacing = drawerHeight;
                        }

                        drawersMax = Math.floor((availableHeight - drawerDistanceFromFloor) / drawerSpacing);

                        if(drawersMax > 4) {
                            defaultDrawers = Math.ceil(drawersMax / 2);
                        } else {
                            defaultDrawers = drawersMax;
                        }

                        shelvesStart = selectedHeight - drawerDistanceFromFloor - (defaultDrawers * drawerSpacing);
                        shelvesMin = 1;
                        shelvesMax = Math.floor(shelvesStart / spaceBetweenShelves);

                    } else if(towerType == 'Shelves') {
                        shelvesMin = 2;
                        shelvesMax = Math.floor((availableHeight - shelfDistanceFromFloor) / spaceBetweenShelves);
                    }

                    setupTowerOptions();
                }
            });

            // Swap options
            $componentOptions.removeClass('shown');
            $towerOptions.addClass('shown');
        });

        // Save options submit
        $saveOptions.find('.action-buttons button').on('click', function(e) {
            e.preventDefault();

            var planTitle = $planTitle.val();

            if(planTitle) {
                // Hide errors
                $saveOptions.find('.form-error').removeClass('shown');

                // Show loader
                $saveOptions.find('.step-form').removeClass('shown').siblings('.step-saving').addClass('shown');

                // Save plan to DB
                $.ajax({
                    method: 'POST',
                    url: planner_api_url + '/planner/save',
                    data: JSON.stringify({
                        plan_type: 'wardrobe',
                        customer_id: customerID,
                        plan_id: planID,
                        plan_title: planTitle,
                        plan: JSON.stringify(canvas.toJSON(['cabjaks', 'hasBorders', 'hasControls', 'selectable', 'hasRotatingPoint', 'lockRotation', 'lockScalingX', 'lockScalingY', 'lockScalingFlip', 'lockUniScaling'])),
                        variables: JSON.stringify(savedVariables),
						customer_tags: customerTags
                    }),
                    timeout: 15000,
                    cache: false,
					contentType: "application/json"
                }).done(function(resultJSON) {
                    var result = resultJSON;
                    if(result.response === 'Success') {
                        $saveOptions.find('.step-saving').removeClass('shown').siblings('.step-saved').addClass('shown');

                        clearTimeout(saveTimer);
                        saveTimer = setTimeout(function() {
                            // Close popup
                            $fullOverlay.removeClass('shown');
                            $saveOptions.removeClass('shown').find('.step-saved').removeClass('shown').siblings('.step-form').addClass('shown');
                        }, 3000);

                        // Next time do update not insert
                        firstSave = false;

                        // Hide prompt if window closed without saving
                        window.onbeforeunload = null;

                    } else {
                        $saveOptions.find('.form-error').addClass('shown').html('<p>Could not save plan. Please try again. (' + result.msg + '.)</p>');
                        $saveOptions.find('.step-saving').removeClass('shown').siblings('.step-form').addClass('shown');
                    }
                }).fail(function() {
                    $saveOptions.find('.form-error').addClass('shown').html('<p>Could not save plan. Please try again. (AJAX error.)</p>');
                    $saveOptions.find('.step-saving').removeClass('shown').siblings('.step-form').addClass('shown');
                });
            } else {
                $saveOptions.find('.form-error').addClass('shown').html('<p>Please enter a title.</p>');
            }
        });

        // Save options cancel
        $saveOptions.find('.action-buttons a.cancel').on('click', function(e) {
            e.preventDefault();

            // Close popup
            hideSaveOptions();
        });

        // Adjust available shelves when choosing the amount of drawers
        $towerDrawersSelect.on('change', function() {
            var selectedDrawers = parseInt($towerDrawersSelect.val(), 10),
            drawerSpacing = null,
            shelvesStart = null;

            if(selectedHeight) {
                if(towerType == 'Drawers') {
                    drawerSpacing = drawerHeight + spaceBetweenDrawers;
                } else if(towerType == 'Drawers and Handles') {
                    drawerSpacing = drawerHeight;
                }

                shelvesStart = selectedHeight - drawerDistanceFromFloor - (selectedDrawers * drawerSpacing);
                shelvesMax = Math.floor(shelvesStart / spaceBetweenShelves);
            }

            setupTowerOptions(false);
        });

        // Product options cancel
        $productOptions.find('.action-buttons a.cancel').on('click', function(e) {
            e.preventDefault();
            isUpdating = false;

            // Close popup
            hideProductOptions();
        });

        // Edit selected product
        $tips.find('p.edit a').on('click', function(e) {
            e.preventDefault();
			
			//disable click for products which can't be edited
			if($(this).parent().hasClass('disabled')){
				return false;
			}

            var cabinet = canvas.getActiveObject();
            isUpdating = true;
            updateOptions = cabinet.cabjaks.cabinetOptions;
            updateLeft = cabinet.getLeft();
            updateTop = cabinet.getTop();
            componentHeight = cabinet.cabjaks.componentHeight;
            componentDrawers = cabinet.cabjaks.componentDrawers;
            componentShelves = cabinet.cabjaks.componentShelves;
            componentType = cabinet.cabjaks.componentType;
            towerType = cabinet.cabjaks.towerType;
            currentProduct = window['product' + currentProductID];
            showProductOptions();
        });

        // Delete selected product
        $('.current-product').find('p.delete a').on('click', function(e) {
            deleteComponent();

            $('.current-product').removeClass('shown');

            e.preventDefault();
        });

        $(document).on('keydown', function(e) {
            // Delete component if delete key pressed
            // Only do this for layout step
            if(currentStep == 3) {
                // On delete or backspace press
                if(e.which == 8 || e.which == 46) {

					//if not trying to save plan
					if(!saveOptions.hasClass('shown')){
						// If object selected
						if(canvas.getActiveObject()) {
							deleteComponent();
						}
						//e.preventDefault();
					}
                }
            }

            // If esc key pressed, close all popups
            if(e.which == 27) {
                if($productOptions.hasClass('shown')) {
                    hideProductOptions();
                }
                if($loadOptions.hasClass('shown')) {
                    hideLoadOptions();
                }

                if($saveOptions.hasClass('shown')) {
                    hideSaveOptions();
                }

                if($customerForm.hasClass('shown') && $login.hasClass('shown')) {
                    hideLogin();
                }

                if($register.hasClass('shown')) {
                    hideRegister();
                }

                if($warning.hasClass('shown')) {
                    hideWarning();
                }
            }
        });
    }

    function bindSelectionEvents(){
       // Additional components - quantity typed
		$additionalComponents.find('input[name=quantity]').on('change', function() {
			if ($(this).closest('.cart__row').is('.rail-supports, .shelf-supports')) {
				suggestedSupportsChanged = true;
			}

			updateAdditionalComponent($(this));
		});

		// Legacy support dropdowns, if any remain
		$additionalComponents.find('select.variant-selector').on('change', function() {
			if ($(this).closest('.cart__row').is('.rail-supports, .shelf-supports')) {
				suggestedSupportsChanged = true;
			}

			updateAdditionalComponent($(this), true);
		});

        $handleSelection.find('.choice').on('click', function() {
            var $this = $(this),
            handleUpgradeID = null,
            handleImageUrl = null,
            handleImageUrl2x = null;
			handleUpgradePrice = $this.find($handleUpgradePrice).data('price');

            handleStyle = $this.find('h3').text();

            if($this.data('id')) {
                handleUpgradeID = $this.data('id');
            }

            if($this.data('img')) {
                handleImageUrl = $this.data('img');
            }

            if($this.data('img')) {
                handleImageUrl2x = $this.data('img2x');
            }

            // Mark choice as selected
            $this.addClass('selected').parent('.grid__item').siblings().find('.choice').removeClass('selected');

            // Loop through existing summary products, remove existing product
            for(var i = 0; i < addtoCartQueue.length; i++) {
                // If there's already a handle upgrade
                if(addtoCartQueue[i].title == handleUpgradeTitle) {
                    handleUpgradeChosen = false;

                    // Remove old item
                    addtoCartQueue.splice(i, 1);
                    break;
                }
            }

            // Add handle upgrade to cart
            if(handleUpgradeID && totalHandles > 0) {
                handleUpgradeChosen = true;

                // Add to summary list
                addtoCartQueue.push({
                    id: handleUpgradeID,
                    title: handleUpgradeTitle,
                    quantity: totalHandles,
                    price: handleUpgradePrice,
                    price_formatted: Shopify.formatMoney(handleUpgradePrice, moneyFormat),
                    line_price: handleUpgradePrice * totalHandles,
                    line_price_formatted: Shopify.formatMoney(handleUpgradePrice * totalHandles, moneyFormat),
                    img: handleImageUrl,
                    img2x: handleImageUrl2x,
                    info: [{
                        title: handleUpgradeVariantTitle,
                        value: handleStyle
                    }],
                    properties: {
                        '_Upgrade Type': 'Wardrobe'
                    }
                });
            }

            // Update price
            updatePrice();

            // Update summary list
            updateSummary();
        });

        $softCloseSelection.find('.choice').on('click', function() {
            var $this = $(this),
            softCloseChoiceText = $this.find('h3').text();

            // Mark choice as selected
            $this.addClass('selected').parent('.grid__item').siblings().find('.choice').removeClass('selected');

            // If standard was chosen
            if(softCloseChoiceText.indexOf("Standard") > -1) {
                // Swap to standard if it's changed
                if(softCloseUpgradeChosen) {
                    swapDrawers(false);
                }

                softCloseStandardChosen = true;
                softCloseUpgradeChosen = false;

            // If an upgrade was chosen
            } else {
                // Swap to soft close if it's changed
                if(!softCloseUpgradeChosen) {
                    swapDrawers();
                }

                softCloseUpgradeChosen = true;
                softCloseStandardChosen = false;
            }
            // Update price
            updatePrice();

            // Update summary list
            updateSummary();
        });

    }

 function bindGlobalEvents() {
    // Add products to cart
    $(document).on('click', 'button.add-to-cart', function(e) {
        e.preventDefault();

        var $this = $(this);

        // Disable add to cart button if enabled in settings
        if (false == true) {
            Swal.fire({
                text: "SORRY the shop is temporaily closed as we are adjusting prices across our site. We hope to have the store back up and running within the next hour. ",
                icon: 'warning',
            });
            return;
        }

        if (addtoCartQueue.length) {
            $this.prop('disabled', true).addClass('is-adding');

            // Save unsaved changes before adding to cart
            if (customerID && !firstSave && window.onbeforeunload !== null) {
                addToCartAfterSave = true;
                savePlan();

                if (addToCartAfterSave) {
                    ajaxAddtoCart();
                }
            } else {
                ajaxAddtoCart();
            }
        }
    });

    // Save button
    $(document).on('click', '.planner-summary-btn-save', function(e) {
        e.preventDefault();

        $saveButton = $wardrobePlanner.find('a.btn-save');

        if (!$saveButton.hasClass('is-saving')) {
            if (customerID) {
                savePlan();
            } else {
                $fullOverlay.addClass('shown');
                $customerForm.addClass('shown');
                $login.addClass('register-shown');
                savePlanAfterLogin = true;
            }
        }
    });

    // Global Save button
    $globalSaveButton.on('click', function(e) {
        e.preventDefault();

        if (!$globalSaveButton.hasClass('is-saving')) {
            if (customerID) {
                roomWidth = $('#room-width').val();
                roomDepth = $('#room-depth').val();
                savePlan();
            } else {
                $fullOverlay.addClass('shown');
                $customerForm.addClass('shown');
                $login.addClass('register-shown');
                savePlanAfterLogin = true;
            }
        }
    });

    // Prepare the latest summary and notes for printing
    function preparePrint() {
        updatePrice();
        updateSummary();
        printNotesList();
        printComponentsList();
    }

    // Refresh for browser printing, including Ctrl+P
    $(window)
        .off('beforeprint.wardrobeComponents')
        .on('beforeprint.wardrobeComponents', preparePrint);

    // Planner Print button
    $('a.btn-print')
        .off('click.wardrobeComponents')
        .on('click.wardrobeComponents', function(e) {
            e.preventDefault();

            preparePrint();
            window.print();
        });

    // Build a print-only components summary
    function printComponentsList() {
        $('.print-components-list').remove();

        if (!addtoCartQueue.length) return;

        var $section = $('<div class="print-components-list"></div>');
        $('<h2></h2>').text('Plan Components').appendTo($section);

        var $table = $('<table></table>');
        $table.append(
            '<thead><tr>' +
            '<th>Component</th><th>Quantity</th><th>Total</th>' +
            '</tr></thead>'
        );

        var $tbody = $('<tbody></tbody>');

        $.each(addtoCartQueue, function(index, item) {
            var $row = $('<tr></tr>');
            var $details = $('<td></td>');

            $('<strong></strong>')
                .text(item.title)
                .appendTo($details);

            $.each(item.info || [], function(infoIndex, info) {
                $('<div class="print-component-detail"></div>')
                    .text(info.title + ': ' + info.value)
                    .appendTo($details);
            });

            $row.append($details);
            $('<td></td>').text(item.quantity).appendTo($row);
            $('<td></td>').text(item.line_price_formatted).appendTo($row);

            $tbody.append($row);
        });

        $table.append($tbody);
        $section.append($table);

        $('<p class="print-components-total"></p>')
            .text('Total (incl GST): ' + finalPriceFormatted)
            .appendTo($section);

        $('<p class="print-components-note"></p>')
            .text('All prices include GST. Shipping is calculated at checkout.')
            .appendTo($section);

        // Place after printed notes, or the canvas if there are no notes
        var $notes = $('.print-notes-list').first();

        if ($notes.length) {
            $notes.after($section);
        } else {
            $('.notes-viewport').first().after($section);
        }
    }

    // Display notes list under canvas for printing
    function printNotesList() {
        $('.print-notes-list').remove();

        var notelist = $('.canvas-container').eq(0).imgNotes('export');

        if (notelist.length > 0) {
            var $notes = $('<div class="print-notes-list"></div>');
            var $list = $('<ul></ul>');

            $('<li class="title"></li>').text('Notes').appendTo($list);

            $.each(notelist, function(index, value) {
                if (value.note !== '') {
                    $('<li></li>')
                        .text((index + 1) + '. ' + value.note)
                        .appendTo($list);
                }
            });

            $notes.append($list);
            $('.notes-viewport').first().after($notes);
        }
    }
}

	// Display notes list under canvas
	function updateNotesList() {
		$('.canvas-notes-list').remove();
		let notelist = $(".canvas-container").eq(0).imgNotes('export');
		if (notelist.length > 0) {
			$('.planner-content').append('<div class="canvas-notes-list"><ul><li class="title">Notes</li></ul></div>');
			$.each(notelist, function( index, value ) {
				if (!(value.note == '')){
					$('.canvas-notes-list ul').append(`<li>${index + 1}. ${value.note}</li>`)
				}
			});
		};
	};

	function bindNoteEvents(){

    }

    function initPlanner(){
        // bind events
        bindProgressEvents();
        bindLoginFormEvents();
        bindStepOneAndTwoEvents();
        bindMessageEvents();
        bindProductsListEvents();
        bindCanvasEvents();
        bindSelectionEvents();
        bindGlobalEvents();
		bindNoteEvents();

        // Reinitialize canvas on window resize
        $(window).on('resize', function() {
            if(roomWidth && roomHeight) {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(initCanvas, 400);
            }
        });

        //mobile view
        if($(window).width() < 990){

            //mobile header toggle
            if(currentStep == 1 || currentStep == 2) {
                //hide products list
                $productsList.removeClass('shown');

                $wardrobePlanner.find('.header-container .nav-toggle').removeClass('shown');
                $(document.body).removeClass('mob-nav-hide');
            }
            else if (currentStep == 3 || currentStep == 4) {
                $wardrobePlanner.find('.header-container .nav-toggle').addClass('shown');
            }

            $wardrobePlanner.find('.header-container .nav-toggle').on('click', function(e) {
                e.preventDefault();
                $(document.body).toggleClass('mob-nav-hide');
            });

            //add cabinet on select product list item
            $productsList.find('.draggable-product').on('click' , function(e){
                e.preventDefault();
                addComponent($(this), $diagram);

                $('html, body').animate({
                    scrollTop: 0
                }, 800);
            });

            headingDescriptionShorten();
        }

        canvas.selection = false;

        canvas.on({
            'object:selected': onComponentSelected,
            'object:moving': onComponentDrag,
            'selection:cleared': onDeselect
        });

        // Update summary list
        updateSummary();

        // Init AutoLoad
        initAutoLoad();
    }

    initPlanner();
};

